// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:36:37.030Z
// Property: Stonehorse Crossing (ID: 6767906449165626)
// Collections: 27 amenities, 6 floorplans (live), 57 photos, 70 POIs, 4 reviews, 1 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165626",
  "property_external_id": "8r93gm0",
  "property_zillow_url": "https://www.zillow.com/apartments/oklahoma-city-ok/stonehorse-crossing/BMj73R/",
  "property_apartments_url": "https://www.apartments.com/stonehorse-crossing-oklahoma-city-ok/8r93gm0/",
  "property_google_business_url": "https://www.google.com/maps/place/Stonehorse+Crossing/data=!4m2!3m1!1s0x0:0x9f1936b7aa285ee6?sa=X&ved=2ahUKEwjSpaS8_7ySAxWZjYkEHTJQEQkQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "stonehorse-crossing",
  "property_name": "Stonehorse Crossing",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/stonehorse-crossing/",
  "property_domain": null,
  "property_address": "14320 Mezzaluna Ave.",
  "property_full_address": "14320 Mezzaluna Ave., Oklahoma City, OK, 73134",
  "property_address_1": "14320 Mezzaluna Ave.",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73134",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Northwest Oklahoma City",
  "property_address_latitude": "35.6175",
  "property_address_longitude": "-97.5598",
  "property_email": "stonehorse@caseusa.com",
  "property_phone": "(405) 993-5057",
  "property_call_tracking_phone": "855-561-0207",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Stonehorse Crossing in Oklahoma City, your ideal home awaits. Choose from spacious one- and two-bedroom floor plans, each boasting modern upgrades like granite countertops and stainless steel appliances. Enjoy resort-style amenities including a sparkling pool, fitness center, and dog park. Schedule a tour today and experience the vibrant lifestyle! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Stonehorse Crossing, where modern living meets exceptional comfort in Oklahoma City! Our vibrant apartment community offers a diverse selection of floor plans, including spacious one and two-bedroom options designed to fit your lifestyle. Each apartment is equipped with top-notch amenities such as air conditioning, stainless steel appliances, granite countertops, and walk-in closets, ensuring all your needs are met.\n\nAt Stonehorse Crossing, we prioritize your well-being and leisure. Dive into the sparkling pool, stay active at our fully-equipped fitness center, or unwind in the stylish clubhouse. Our friendly on-site management team is available 24/7, providing you with unparalleled support and maintenance services. You'll also enjoy exclusive community features, including a business center, lounge, and multi-use room, perfect for socializing or working from home.\n\nStep outside to discover beautifully landscaped courtyards, a relaxing sundeck, and picnic areas with grills for your afternoon barbecues. Pet lovers will appreciate our dog park, where your furry friends can roam and play freely. With controlled access and gated entry, your safety is our priority.\n\nLocated in the heart of Oklahoma City, Stonehorse Crossing is just minutes away from shopping, dining, and entertainment options, making it the ideal place to call home. \n\nDon’t miss the opportunity to elevate your living experience—find your new home today! Browse our availability or schedule a tour to visit our community and see all that Stonehorse Crossing has to offer. Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb48-82db-76d9-b03d-338231fdc4e1.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment buildings with a pool and manicured landscaping.",
    "public_id": "019cfb48-82db-76d9-b03d-338231fdc4e1",
    "storage_key": "property/6767906449165626/019cfb48-82db-76d9-b03d-338231fdc4e1.webp",
    "width": 2048,
    "height": 1366
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "300",
  "property_year_built": "2018",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.66666666666667",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "80",
  "property_pet_restrictions": "Pets up to 80lbs",
  "property_pet_policy_description": "Above applies to Pets  up to 80lbs",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://stonehorsecrossingapartmentsoklahomacity.securecafe.com/onlineleasing/stonehorse-crossing/floorplans.aspx",
  "property_resident_portal_url": "https://stonehorsecrossingapartmentsoklahomacity.securecafe.com/residentservices/stonehorse-crossing/userlogin.aspx",
  "property_apply_now_url": "https://stonehorsecrossingapartmentsoklahomacity.securecafe.com/onlineleasing/stonehorse-crossing/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-6d6b-74fb-b8aa-a92e079e3163.webp",
  "property_primary_logo_media": {
    "alt_text": "Stonehorse Crossing logo with a horse head and the words Stonehorse Crossing.",
    "public_id": "019cfb47-6d6b-74fb-b8aa-a92e079e3163",
    "storage_key": "property/6767906449165626/019cfb47-6d6b-74fb-b8aa-a92e079e3163.webp",
    "width": 341,
    "height": 155
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb48-6cb9-7598-8697-ed5b8ed29879.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb48-6cb9-7598-8697-ed5b8ed29879",
    "storage_key": "property/6767906449165626/019cfb48-6cb9-7598-8697-ed5b8ed29879.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb48-91d4-756f-a7c5-9a7f99ceb72e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Stonehorse Crossing logo with a horse silhouette and text.",
    "public_id": "019cfb48-91d4-756f-a7c5-9a7f99ceb72e",
    "storage_key": "property/6767906449165626/019cfb48-91d4-756f-a7c5-9a7f99ceb72e.webp",
    "width": 341,
    "height": 155
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb48-991a-76b7-87dc-c7288e6de826.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Stonehorse Crossing logo with a horse silhouette and the text \"Stonehorse Crossing\".",
    "public_id": "019cfb48-991a-76b7-87dc-c7288e6de826",
    "storage_key": "property/6767906449165626/019cfb48-991a-76b7-87dc-c7288e6de826.webp",
    "width": 341,
    "height": 155
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#00aebc",
  "property_secondary_color": "#3d3d3f",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#cac4b8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1267",
  "property_sqft_min": "789",
  "property_sqft_max": "1267",
  "property_price_range": "1159 - 1619",
  "property_price_min": "1159",
  "property_price_max": "1619",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/StonehorseOKC/",
  "property_instagram_url": "https://www.instagram.com/stonehorsecrossing/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJa-iThsodsocR5l4oqrc2GZ8",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/stonehorse-crossing-oklahoma-city",
  "property_tiktok_url": "https://www.tiktok.com/@stonehorsecrossingapts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Stonehorse Crossing",
  "property_home_romance_title": "Embrace the Joy of Living at Our Charming Community",
  "property_home_amenities_blurb": "Welcome to Stonehorse Crossing, where comfort meets convenience in vibrant Oklahoma City. Choose from stunning one- and two-bedroom floor plans with modern features like granite countertops and stainless steel appliances. Enjoy our sparkling pool, fitness center, and tranquil dog park—all designed to elevate your living experience. Embrace your new lifestyle today!",
  "property_home_floorplans_blurb": "At Stonehorse Crossing in Oklahoma City, our thoughtfully designed one and two-bedroom apartments offer the ideal blend of comfort and style. Experience modern living with spacious layouts and inviting amenities. Browse our available apartment homes today to find the perfect floor plan that suits your lifestyle and needs.",
  "property_home_gallery_blurb": "At Stonehorse Crossing in Oklahoma City, luxury meets comfort in our stylish one and two-bedroom apartments. Enjoy resort-style amenities like a refreshing pool, a state-of-the-art fitness center, and a cozy clubhouse. With features like granite countertops and spacious walk-in closets, picture yourself living in your ideal home today!",
  "property_home_neighborhood_blurb": "Nestled in vibrant Oklahoma City, Stonehorse Crossing offers exceptional one- and two-bedroom apartments with access to diverse neighborhood gems. From quaint cafes to bustling parks, our community is surrounded by local favorites that embody the spirit of Oklahoma City. Uncover the charm that awaits just outside your door!",
  "property_home_reviews_blurb": "At Stonehorse Crossing in Oklahoma City, residents rave about the vibrant community spirit, stating, “It feels like home the moment you move in.” Experience a lifestyle filled with comfort and camaraderie. See what our residents have to say about living at our community and join us today!",
  "property_neighborhood_blurb": "At Stonehorse Crossing in Oklahoma City, your new home is surrounded by esteemed institutions like the University of Central Oklahoma and Oklahoma Christian University. Enjoy proximity to Angie Debo Elementary, Summit Middle School, and Southern Nazarene University, making it easy to stay connected to learning. See what’s around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Stonehorse Crossing in vibrant Oklahoma City, unwind by the sparkling pool, break a sweat in our fitness center, or relax in the cozy clubhouse. Enjoy stylish one and two-bedroom apartments featuring granite countertops, vaulted ceilings, and a dog park for your furry friends. Embrace comfort and convenience in our captivating community!",
  "property_applynow_blurb": "At Stonehorse Crossing in Oklahoma City, enjoy stylish living with thoughtfully designed one and two-bedroom floor plans. Dive into upscale amenities like a refreshing pool, a state-of-the-art fitness center, and a serene dog park—perfect for unwinding. Your new home awaits; lease online today and elevate your living experience!",
  "property_contactus_blurb": "At Stonehorse Crossing in Oklahoma City, our thoughtfully designed one and two-bedroom floor plans offer a perfect blend of comfort and style. Each space is crafted for modern living, inviting you to create a home that reflects your lifestyle. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Stonehorse Crossing in Oklahoma City, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. From spacious living areas to modern amenities, we prioritize comfort and convenience. Have questions? Our FAQs page is your go-to resource for everything you need to know about our vibrant community.",
  "property_floorplans_blurb": "At Stonehorse Crossing in Oklahoma City, spacious living awaits with our thoughtfully designed one and two-bedroom floor plans. Each home invites comfort and style, tailored to suit your lifestyle. Browse our available apartment homes today and uncover the ideal space for your modern living experience.",
  "property_gallery_blurb": "At Stonehorse Crossing in Oklahoma City, vibrant living takes shape with stunning one and two-bedroom floor plans. Picture unwinding by the pool, enjoying serene courtyard picnics, or focusing at our business center. Each apartment boasts modern amenities like granite countertops and spacious walk-in closets. Life here isn’t just comfortable; it’s captivating!",
  "property_interactivemap_blurb": "At Stonehorse Crossing in vibrant Oklahoma City, your ideal apartment awaits. Choose from stylish one- or two-bedroom floor plans, complemented by an array of exceptional amenities. Enjoy sunny afternoons by the pool, invigorating workouts in our fitness center, or cozy evenings at the fire pit. Dive into our interactive community map to find your new home today!",
  "property_pets_blurb": "At Stonehorse Crossing in Oklahoma City, your ideal lifestyle awaits. With spacious apartments and delightful amenities, our community offers a tranquil retreat. Embrace the company of furry friends—pets up to 80lbs can thrive here! Experience comfort and convenience nestled in a vibrant neighborhood that truly feels like home.",
  "property_referafriend_blurb": "At Stonehorse Crossing in Oklahoma City, our vibrant community offers spacious one and two-bedroom floor plans designed for comfort and style. Great friends make great neighbors—share the experience of modern living and the welcoming atmosphere by referring a friend today! Your ideal home awaits together!",
  "property_residentaccess_blurb": "At Stonehorse Crossing in vibrant Oklahoma City, a diverse array of floor plans awaits—choose from cozy one-bedroom or spacious two-bedroom apartments. Unlock seamless living through our resident portal: easily pay rent, schedule maintenance, and enhance your community experience right from home. Your convenience is just a click away!",
  "property_reviews_blurb": "At Stonehorse Crossing in vibrant Oklahoma City, residents rave about a \"welcoming atmosphere\" and \"responsive management.\" This thriving community fosters connections and comfort, making it easy to call home. Curious about the experiences of fellow neighbors? Check out their heartfelt testimonials and see what they love about living here!",
  "property_created_at": "1753982391687",
  "property_scheduletour_blurb": "At Stonehorse Crossing in Oklahoma City, our diverse floor plans are designed for your lifestyle—choose from spacious one and two-bedroom options. Experience the vibrant community that makes home feel like a retreat. Schedule a tour today and see why residents rave about life at Stonehorse Crossing!",
  "property_thankyou_blurb": "Thank you for reaching out to Stonehorse Crossing in Oklahoma City! Our diverse floor plans, featuring one and two-bedroom options, are designed to cater to your lifestyle. A member of our team will connect with you soon to help you find your perfect home. Stay tuned for exciting updates!",
  "property_virtualtours_blurb": "At Stonehorse Crossing in Oklahoma City, unwind in our thoughtfully designed one and two-bedroom apartments, where modern living meets comfort. Experience inviting spaces and breathtaking views. Ready to envision your new home? Take a virtual tour today and let your next chapter begin!",
  "property_copyright": "2025 All Rights Reserved. Stonehorse Crossing",
  "property_seo_title_home": "Stonehorse Crossing | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_home": "Experience luxury living at Stonehorse Crossing in OKC! Enjoy spacious layouts, top-notch amenities like a pool, fitness center, and dog park. Your dream home awaits!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_floorplans": "Find your ideal space at Stonehorse Crossing in OKC! Choose from stylish one or two-bedroom floor plans tailored for your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience the vibrant lifestyle at Stonehorse Crossing in Oklahoma City! With a pool, fitness center, and stylish apartments, your perfect home awaits.",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_gallery": "\"At Stonehorse Crossing in OKC, envision your life surrounded by upscale amenities—pool, fitness center, and spacious floor plans. Picture yourself living here!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Stonehorse Crossing Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Stonehorse Crossing in Oklahoma City! Take a virtual tour and envision your new home with our one and two-bedroom floor plans.",
  "property_seo_title_interactivemap": "Interactive Map | Stonehorse Crossing Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Stonehorse Crossing in Oklahoma City! Enjoy luxury amenities, spacious floor plans, and an interactive map to explore your future oasis.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood of Stonehorse Crossing in Oklahoma City. Dive into local hotspots and hidden gems just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Stonehorse Crossing",
  "property_seo_description_contact": "Experience the comfort of Stonehorse Crossing in Oklahoma City. Browse our one and two-bedroom floor plans and connect with our leasing team for inquiries!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_faqs": "Uncover your next home at Stonehorse Crossing in OKC! Get all your community questions answered and make the most of our luxurious amenities.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_reviews": "Join the vibrant community at Stonehorse Crossing in OKC! With top-notch amenities and spacious floor plans, see why our residents love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_applynow": "Find your perfect haven at Stonehorse Crossing in Oklahoma City! Choose from stylish one- and two-bedroom apartments with resort-style amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Stonehorse Crossing",
  "property_seo_description_residentaccess": "Log in to Stonehorse Crossing's resident portal to manage your rent, request maintenance, and enjoy a seamless living experience in Oklahoma City!",
  "property_seo_title_referafriend": "Refer A Friend | Stonehorse Crossing",
  "property_seo_description_referafriend": "\"Refer a friend to Stonehorse Crossing in OKC! Great friends make great neighbors—share the love of our vibrant community and enjoy exclusive rewards!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Stonehorse Crossing",
  "property_seo_description_scheduletour": "Step into luxury at Stonehorse Crossing in Oklahoma City! Experience spacious living and vibrant amenities. Schedule your tour and envision your new home today!",
  "property_seo_title_privacy": "Privacy Policy | Stonehorse Crossing",
  "property_seo_description_privacy": "Your privacy matters at Stonehorse Crossing. Learn how we protect your information in our comprehensive privacy policy. Read it today for peace of mind!",
  "property_seo_title_accessibility": "Website Accessibility | Stonehorse Crossing",
  "property_seo_description_accessibility": "At Stonehorse Crossing in Oklahoma City, we champion digital access for all. Join a community where everyone is welcome and empowered online!",
  "property_seo_title_sitemap": "Sitemap | Stonehorse Crossing",
  "property_seo_description_sitemap": "Unravel the amenities and layouts at Stonehorse Crossing in Oklahoma City. Access our sitemap to find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Stonehorse Crossing",
  "property_seo_description_thankyou": "Thank you for reaching out to Stonehorse Crossing! A team member will be in touch soon to help you find your ideal apartment in vibrant Oklahoma City.",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865786033",
  "amenities": [
    {
      "id": "ec_728682294f5a96852b089124",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127397138",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84c3fd787a9c04afdb1f7f94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127397139",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18c890bd13a5db037cde4c3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127397140",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7427907677931a213240485",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127397141",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3044a00c5bd0a3c2fb062a89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127397142",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13f7c3d749a5042e5eda5433",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127397143",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f197926d4843b6fdba273f66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127397144",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e4fb7ef471c53226f82457b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127397145",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d54bb1983576261942d00bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127397146",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40ba6c60ac49cecdf7a4f08a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127397149",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17e92a015721dfb10df66fe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "128042554",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd4e291e5e13ab39ec93d371",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127397153",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c42580ad34425ea795c93356",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "128017312",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82a96d1c45ba6a6aa402695c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398596",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30b652b0be9a548f276fc1d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398597",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_274bf56c142aa04d74ca1cea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398598",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef4755a45a563c55a06c8d37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398599",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d4c5dda8508d9c17c9e336d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398600",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0477dd7025340f559d238a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398601",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38baa7bd8da3bab17a20ce73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398602",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_912e9089acf7f9dd54e46894",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398603",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9113a391698166d32f6f1023",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398604",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b842b9d318d65b16842c151e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398605",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3bf9d2ea95fd3b6c715d80a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398606",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c60a27673d636992c3379b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398607",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b97f6275d8cd3cee7977dd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398608",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_121b327ba352fded33a3a5cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "yardi",
      "external_id": "127398609",
      "title": "Furnished",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_619d6dcf-e7cd-41fe-bc65-4234647df964",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-bcc9-71a2-81ab-574ee88b2ba4.webp",
      "image_media": {
        "alt_text": "Stonehorse Crossing entrance sign with stone pillars and landscaping.",
        "public_id": "019d20af-bcc9-71a2-81ab-574ee88b2ba4",
        "storage_key": "property/6767906449165626/019d20af-bcc9-71a2-81ab-574ee88b2ba4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior entrance sign for Stonehorse Crossing apartment community featuring stone pillars, wood panel, and landscaping.",
      "link": "",
      "alt_text": "Stonehorse Crossing entrance sign with stone pillars and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-1c5f-75e7-81fc-8a23b6086ae3.webp"
    },
    {
      "id": "custom_02a3c9e7-6188-448c-a7b2-1821b49311b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-bc7f-7776-8737-a02508e25fde.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-building apartment community with a fenced dog park and playground.",
        "public_id": "019d20af-bc7f-7776-8737-a02508e25fde",
        "storage_key": "property/6767906449165626/019d20af-bc7f-7776-8737-a02508e25fde.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "A pet-friendly apartment community with a fenced dog park and playground, set against modern multi-story buildings.",
      "link": "",
      "alt_text": "Exterior of a multi-building apartment community with a fenced dog park and playground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-6dca-73bf-9d8d-fb9be91b4803.webp"
    },
    {
      "id": "custom_43dd9672-7de5-4506-8edf-b1a793ec1c25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-bd35-72dc-a082-b38202510158.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern multifamily building with stone accents, balconies, and a white fence.",
        "public_id": "019d20af-bd35-72dc-a082-b38202510158",
        "storage_key": "property/6767906449165626/019d20af-bd35-72dc-a082-b38202510158.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior of a contemporary apartment community with townhome-style buildings, stone and brick accents, and a white fence.",
      "link": "",
      "alt_text": "Exterior view of a modern multifamily building with stone accents, balconies, and a white fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-2512-755e-8373-972b084504b5.webp"
    },
    {
      "id": "custom_632159df-fb81-4e96-9b25-39e7967deb5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-bc46-7754-91a4-f0f5c074771d.webp",
      "image_media": {
        "alt_text": "Exterior view of a gated apartment community entrance with brick columns, stone accents, and landscaped grounds.",
        "public_id": "019d20af-bc46-7754-91a4-f0f5c074771d",
        "storage_key": "property/6767906449165626/019d20af-bc46-7754-91a4-f0f5c074771d.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Gated entry to a modern apartment community with brick columns, stone accents, and landscaped greens.",
      "link": "",
      "alt_text": "Exterior view of a gated apartment community entrance with brick columns, stone accents, and landscaped grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-6dc6-7422-af07-f0aaeca4851c.webp"
    },
    {
      "id": "custom_3db36398-7c01-4365-8239-376331589f90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-c67e-736f-a675-04a8ab7e119f.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily community building with stone entrance, metal roof, and front parking lot.",
        "public_id": "019d20af-c67e-736f-a675-04a8ab7e119f",
        "storage_key": "property/6767906449165626/019d20af-c67e-736f-a675-04a8ab7e119f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior of a modern multifamily community with a stone entry, metal roof, and well-kept landscaping.",
      "link": "",
      "alt_text": "Exterior view of a multifamily community building with stone entrance, metal roof, and front parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-366d-71fd-ab8d-9af811c1a43f.webp"
    },
    {
      "id": "custom_5d1d29c3-124d-474c-825f-4f973178bb21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-c6b6-71da-914a-014324ff544d.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-building apartment community with a central pool and landscaped courtyards.",
        "public_id": "019d20af-c6b6-71da-914a-014324ff544d",
        "storage_key": "property/6767906449165626/019d20af-c6b6-71da-914a-014324ff544d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community with balconies, a pool, and landscaped common areas.",
      "link": "",
      "alt_text": "Exterior view of a multi-building apartment community with a central pool and landscaped courtyards.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-1c4d-755b-b88a-3c4144400c3a.webp"
    },
    {
      "id": "custom_e6d6df12-f2f7-4ed4-8d8e-9df23c106b2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-cedf-7131-bf74-0b1a345bc852.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-building apartment community with a fenced dog park and playground.",
        "public_id": "019d20af-cedf-7131-bf74-0b1a345bc852",
        "storage_key": "property/6767906449165626/019d20af-cedf-7131-bf74-0b1a345bc852.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Canine Crossing, a pet-friendly apartment community with multiple buildings, balconies, and a fenced dog park.",
      "link": "",
      "alt_text": "Exterior of a multi-building apartment community with a fenced dog park and playground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-1ffb-704c-851b-d8719f1afaad.webp"
    },
    {
      "id": "custom_489c92b9-13e4-41be-bca0-71264818237d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-cebf-77d2-a6b9-e8a3566ecd0c.webp",
      "image_media": {
        "alt_text": "Outdoor community lounge with a stone fireplace, grills, and cushioned seating under a wooden pergola.",
        "public_id": "019d20af-cebf-77d2-a6b9-e8a3566ecd0c",
        "storage_key": "property/6767906449165626/019d20af-cebf-77d2-a6b9-e8a3566ecd0c.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Spacious outdoor amenity area with grilling stations, a stone fireplace, and comfortable seating for residents.",
      "link": "",
      "alt_text": "Outdoor community lounge with a stone fireplace, grills, and cushioned seating under a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-7c31-74d2-a67c-aa5902cf8a06.webp"
    },
    {
      "id": "custom_36323d75-36e3-412b-a4c8-794371a571fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-d3f1-774f-9339-cd2db3534fb9.webp",
      "image_media": {
        "alt_text": "Outdoor community pool with blue water, lounge chairs, and an apartment building in the background.",
        "public_id": "019d20af-d3f1-774f-9339-cd2db3534fb9",
        "storage_key": "property/6767906449165626/019d20af-d3f1-774f-9339-cd2db3534fb9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment community featuring a resort-style pool, sun loungers, umbrellas, and landscaped grounds.",
      "link": "",
      "alt_text": "Outdoor community pool with blue water, lounge chairs, and an apartment building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-24c6-70d9-8574-04e8c37f2c71.webp"
    },
    {
      "id": "custom_654c1b39-592f-408b-a2eb-700b171243c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-d66d-767b-b7e2-5f73cbaf3722.webp",
      "image_media": {
        "alt_text": "Outdoor apartment community pool with blue water, yellow lounge chairs, and surrounding buildings.",
        "public_id": "019d20af-d66d-767b-b7e2-5f73cbaf3722",
        "storage_key": "property/6767906449165626/019d20af-d66d-767b-b7e2-5f73cbaf3722.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Bright pool area at a modern apartment community with lounge chairs and shaded seating.",
      "link": "",
      "alt_text": "Outdoor apartment community pool with blue water, yellow lounge chairs, and surrounding buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-6c91-703f-b631-2d1b19bd206b.webp"
    },
    {
      "id": "custom_52cb4462-bd4d-4d39-a7ca-d52767b808c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-dba9-7548-8059-96cfb3cd04cd.webp",
      "image_media": {
        "alt_text": "Interior view of a modern gym with cardio machines, free weights, a weight rack, and medicine balls.",
        "public_id": "019d20af-dba9-7548-8059-96cfb3cd04cd",
        "storage_key": "property/6767906449165626/019d20af-dba9-7548-8059-96cfb3cd04cd.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Indoor fitness center at the community featuring cardio equipment, free weights, and medicine balls.",
      "link": "",
      "alt_text": "Interior view of a modern gym with cardio machines, free weights, a weight rack, and medicine balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-df9d-7258-9694-8bb4c24ed91c.webp"
    },
    {
      "id": "custom_bb475b03-cac9-4d68-9852-1ae3efd28bb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-ddfb-7328-9f70-16801e36dc5a.webp",
      "image_media": {
        "alt_text": "Bright apartment lobby with vaulted ceiling, exposed wooden beams, circular chandeliers, stone fireplace, and yellow seating.",
        "public_id": "019d20af-ddfb-7328-9f70-16801e36dc5a",
        "storage_key": "property/6767906449165626/019d20af-ddfb-7328-9f70-16801e36dc5a.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Inviting community lobby with a stone fireplace, modern yellow seating, and large windows that flood the space with natural light.",
      "link": "",
      "alt_text": "Bright apartment lobby with vaulted ceiling, exposed wooden beams, circular chandeliers, stone fireplace, and yellow seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-ee6a-70e8-8372-94a0897c84f1.webp"
    },
    {
      "id": "custom_39287b9e-cc49-4078-a754-aed5ecd854dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-e249-730c-8cfa-170c04ef109e.webp",
      "image_media": {
        "alt_text": "Bright communal lobby with a stone reception desk, teal seating, and tall windows.",
        "public_id": "019d20af-e249-730c-8cfa-170c04ef109e",
        "storage_key": "property/6767906449165626/019d20af-e249-730c-8cfa-170c04ef109e.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Contemporary apartment community lobby with a stone reception desk, colorful seating, and expansive windows.",
      "link": "",
      "alt_text": "Bright communal lobby with a stone reception desk, teal seating, and tall windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-f2ff-76f5-a77c-a51652a10b38.webp"
    },
    {
      "id": "custom_0acc4d88-bd49-4fac-bdc1-bc7ae32af3c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-e82a-71ea-8569-af4feacd817d.webp",
      "image_media": {
        "alt_text": "Open communal lounge with a full kitchen, island seating, a pool table, and teal accent wall.",
        "public_id": "019d20af-e82a-71ea-8569-af4feacd817d",
        "storage_key": "property/6767906449165626/019d20af-e82a-71ea-8569-af4feacd817d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Spacious resident lounge with a modern kitchen, island seating, pool table, and workstations.",
      "link": "",
      "alt_text": "Open communal lounge with a full kitchen, island seating, a pool table, and teal accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-1540-7733-ae79-659a2f36fa82.webp"
    },
    {
      "id": "custom_32651bda-0a7b-4dc9-be2a-1e61cfe5f067",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-e8d1-7288-9e9f-5a154f9823e7.webp",
      "image_media": {
        "alt_text": "Indoor community game room with pool table, foosball and TVs.",
        "public_id": "019d20af-e8d1-7288-9e9f-5a154f9823e7",
        "storage_key": "property/6767906449165626/019d20af-e8d1-7288-9e9f-5a154f9823e7.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Modern resident amenities room with pool table, foosball, and large TVs for social recreation.",
      "link": "",
      "alt_text": "Indoor community game room with pool table, foosball and TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-df9d-7258-9694-8da5ec5ffcbb.webp"
    },
    {
      "id": "custom_6b9d52d9-4987-4ee9-ad51-1ae0f125dd3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-ef1d-7613-9a41-518c8c1b54df.webp",
      "image_media": {
        "alt_text": "Outdoor community area with a stone fireplace, string lights, grills, and cushioned seating.",
        "public_id": "019d20af-ef1d-7613-9a41-518c8c1b54df",
        "storage_key": "property/6767906449165626/019d20af-ef1d-7613-9a41-518c8c1b54df.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "An outdoor resident lounge with a stone fireplace, built-in grills, and comfortable seating under string lights.",
      "link": "",
      "alt_text": "Outdoor community area with a stone fireplace, string lights, grills, and cushioned seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-190a-73bb-9f65-1fa581941616.webp"
    },
    {
      "id": "custom_4ff86965-91f1-409a-bed8-e1ac6a2738fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-f556-740b-97b5-787d1294d305.webp",
      "image_media": {
        "alt_text": "Interior gym at a multifamily community with cardio machines, free weights, and a mirrored wall.",
        "public_id": "019d20af-f556-740b-97b5-787d1294d305",
        "storage_key": "property/6767906449165626/019d20af-f556-740b-97b5-787d1294d305.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Modern on-site fitness center featuring cardio machines, free weights, and a mirrored workout space.",
      "link": "",
      "alt_text": "Interior gym at a multifamily community with cardio machines, free weights, and a mirrored wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-6da8-739b-a2c2-72aa22099b6f.webp"
    },
    {
      "id": "custom_7f72e4bc-cc01-461f-9804-3018b43b994a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-fa72-70b4-afa4-0cf59d25bf54.webp",
      "image_media": {
        "alt_text": "Indoor community lounge with a pool table, open kitchen, and glass garage-style doors.",
        "public_id": "019d20af-fa72-70b4-afa4-0cf59d25bf54",
        "storage_key": "property/6767906449165626/019d20af-fa72-70b4-afa4-0cf59d25bf54.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Modern resident lounge with billiards, an open kitchen, and casual seating for gatherings.",
      "link": "",
      "alt_text": "Indoor community lounge with a pool table, open kitchen, and glass garage-style doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-6ca1-7551-9679-a161d93037b5.webp"
    },
    {
      "id": "custom_8ddf7e1b-6464-453d-a177-59ccf0ceea81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20af-fe42-75f3-a431-586f76b308a5.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment living area with a desk, chair, and artwork.",
        "public_id": "019d20af-fe42-75f3-a431-586f76b308a5",
        "storage_key": "property/6767906449165626/019d20af-fe42-75f3-a431-586f76b308a5.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Modern apartment living space with a workspace, contemporary art, and a cozy seating area.",
      "link": "",
      "alt_text": "Interior view of a modern apartment living area with a desk, chair, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-dfdf-759a-bbd0-79426e3fdf15.webp"
    },
    {
      "id": "custom_b5de3d46-0981-4b83-b0da-04ff8d82ba60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-0353-71ea-9058-82c4a85abd9c.webp",
      "image_media": {
        "alt_text": "Bedroom in a modern apartment with wood bed, two nightstands, lamps, and ceiling fan.",
        "public_id": "019d20b0-0353-71ea-9058-82c4a85abd9c",
        "storage_key": "property/6767906449165626/019d20b0-0353-71ea-9058-82c4a85abd9c.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Cozy bedroom in a stylish apartment featuring a wooden bed, matching nightstands, and decorative wall art.",
      "link": "",
      "alt_text": "Bedroom in a modern apartment with wood bed, two nightstands, lamps, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-dfdf-759a-bbd0-7e139bfe4d85.webp"
    },
    {
      "id": "custom_9afc6f11-40da-4595-876b-696bbe307fb2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-038a-7178-9bdf-3869fdde821a.webp",
      "image_media": {
        "alt_text": "Interior of a community lounge with orange sofa, chairs, fireplace, and TV.",
        "public_id": "019d20b0-038a-7178-9bdf-3869fdde821a",
        "storage_key": "property/6767906449165626/019d20b0-038a-7178-9bdf-3869fdde821a.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Community",
      "description": "Spacious resident lounge with cozy seating, a fireplace, and a TV in the community clubhouse.",
      "link": "",
      "alt_text": "Interior of a community lounge with orange sofa, chairs, fireplace, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-dfe9-76f5-8423-89a652e183b2.webp"
    },
    {
      "id": "custom_218adbdf-7c79-47d6-a230-a55e24f4d815",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-04ea-74a4-b968-c2d1a6abdfa1.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white wire shelves along two walls and woven baskets on the carpet.",
        "public_id": "019d20b0-04ea-74a4-b968-c2d1a6abdfa1",
        "storage_key": "property/6767906449165626/019d20b0-04ea-74a4-b968-c2d1a6abdfa1.webp",
        "width": 2457,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Walk-in closet with multiple white wire shelves and woven baskets for organized storage.",
      "link": "",
      "alt_text": "Walk-in closet with white wire shelves along two walls and woven baskets on the carpet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-dfbe-750d-bfd4-07a7a99a206d.webp"
    },
    {
      "id": "custom_2d3ab22c-aa88-4d44-885b-d3e622d9e611",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-0d90-736e-a799-e23951396eb1.webp",
      "image_media": {
        "alt_text": "Open-concept living area with a green sofa, glass coffee table, and bar stools at the kitchen island.",
        "public_id": "019d20b0-0d90-736e-a799-e23951396eb1",
        "storage_key": "property/6767906449165626/019d20b0-0d90-736e-a799-e23951396eb1.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Spacious apartment living area with a modern kitchen, cozy seating, and abundant natural light from large windows.",
      "link": "",
      "alt_text": "Open-concept living area with a green sofa, glass coffee table, and bar stools at the kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-dfdb-74b6-98b3-3773b3ca326d.webp"
    },
    {
      "id": "custom_ce1300b4-b0e4-4e9e-8040-ddb17ecf0cfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-1119-7334-9c9e-243d6bd16b7f.webp",
      "image_media": {
        "alt_text": "Bedroom in a neutral-toned apartment with a wooden bed, dresser, and round mirror.",
        "public_id": "019d20b0-1119-7334-9c9e-243d6bd16b7f",
        "storage_key": "property/6767906449165626/019d20b0-1119-7334-9c9e-243d6bd16b7f.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Cozy bedroom in a modern apartment with warm wood furniture, soft lighting, and calming blue accents.",
      "link": "",
      "alt_text": "Bedroom in a neutral-toned apartment with a wooden bed, dresser, and round mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-dfd5-773b-a12c-a2685e2b447b.webp"
    },
    {
      "id": "custom_65ac8703-19d4-4cb9-a7af-6190d4b31993",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-1512-75be-b430-a199838e847c.webp",
      "image_media": {
        "alt_text": "Apartment bathroom with marble countertop vanity, mirror, toilet, and teal shower curtain.",
        "public_id": "019d20b0-1512-75be-b430-a199838e847c",
        "storage_key": "property/6767906449165626/019d20b0-1512-75be-b430-a199838e847c.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring marble vanity, dark cabinets, and teal accents.",
      "link": "",
      "alt_text": "Apartment bathroom with marble countertop vanity, mirror, toilet, and teal shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-dfa2-719d-8e05-9c868bbc085a.webp"
    },
    {
      "id": "custom_2849dd6d-460f-4c7d-ae53-a3d6acd98e86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-1524-7042-bed4-a8809719efb8.webp",
      "image_media": {
        "alt_text": "Open-concept living room with sofa, coffee table, wall-mounted TV, and an electric fireplace.",
        "public_id": "019d20b0-1524-7042-bed4-a8809719efb8",
        "storage_key": "property/6767906449165626/019d20b0-1524-7042-bed4-a8809719efb8.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Open-concept living area with a fireplace, cozy seating, and a modern kitchen with a breakfast bar.",
      "link": "",
      "alt_text": "Open-concept living room with sofa, coffee table, wall-mounted TV, and an electric fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-e6dc-711f-96d6-f4fd40798e6a.webp"
    },
    {
      "id": "custom_e15a9fa1-45fa-4f83-b406-572926306fd3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-1a5e-720d-a35d-540193374eba.webp",
      "image_media": {
        "alt_text": "Living room with a desk, fur chair, green sofa, and round dining table by large windows.",
        "public_id": "019d20b0-1a5e-720d-a35d-540193374eba",
        "storage_key": "property/6767906449165626/019d20b0-1a5e-720d-a35d-540193374eba.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Bright living area with a workspace, plush seating, and a dining nook for entertaining.",
      "link": "",
      "alt_text": "Living room with a desk, fur chair, green sofa, and round dining table by large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-eea6-71de-8c3c-16b267727dd2.webp"
    },
    {
      "id": "custom_aa19cb53-bba2-47a3-9590-32ea94085a5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-20d8-75bb-abca-79c1da048b99.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen and living room in a modern apartment with white cabinets and stainless appliances.",
        "public_id": "019d20b0-20d8-75bb-abca-79c1da048b99",
        "storage_key": "property/6767906449165626/019d20b0-20d8-75bb-abca-79c1da048b99.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area with a full kitchen, island, and cozy seating.",
      "link": "",
      "alt_text": "Open-concept kitchen and living room in a modern apartment with white cabinets and stainless appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-eee3-72e0-8db0-767df033ab86.webp"
    },
    {
      "id": "custom_8ef692cc-167a-4278-b92e-2cf9fe49dc0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-214a-711e-b009-2a394bf252f1.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a queen bed, teal curtains, a tall dresser, and a ceiling fan.",
        "public_id": "019d20b0-214a-711e-b009-2a394bf252f1",
        "storage_key": "property/6767906449165626/019d20b0-214a-711e-b009-2a394bf252f1.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with a queen bed, teal accents, a tall dresser, and warm lighting.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a queen bed, teal curtains, a tall dresser, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-ef68-74fc-949e-c2beca5b87a6.webp"
    },
    {
      "id": "custom_40946d1d-1d5e-4c4b-86c8-0f2458007bbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-23df-73df-9c91-28f34f86b75c.webp",
      "image_media": {
        "alt_text": "Open kitchen with island, white cabinets, stainless steel fridge, and bar stools.",
        "public_id": "019d20b0-23df-73df-9c91-28f34f86b75c",
        "storage_key": "property/6767906449165626/019d20b0-23df-73df-9c91-28f34f86b75c.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen with white cabinets, dark countertops, a stainless steel fridge, and a breakfast island.",
      "link": "",
      "alt_text": "Open kitchen with island, white cabinets, stainless steel fridge, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-f119-77f3-b85d-27642339a479.webp"
    },
    {
      "id": "custom_06e3c4bf-10c4-49f9-9e86-9b1753bc5def",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-2b49-725d-a04e-491096c543f7.webp",
      "image_media": {
        "alt_text": "Bedroom with dark wood bed frame, two nightstands, dresser, ceiling fan, and wall art.",
        "public_id": "019d20b0-2b49-725d-a04e-491096c543f7",
        "storage_key": "property/6767906449165626/019d20b0-2b49-725d-a04e-491096c543f7.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Spacious bedroom in a modern apartment with dark wood furniture, plush bedding, and warm lighting for a welcoming retreat.",
      "link": "",
      "alt_text": "Bedroom with dark wood bed frame, two nightstands, dresser, ceiling fan, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-f20e-70ba-97a0-b18ddb39801d.webp"
    },
    {
      "id": "custom_1c2fbc30-b86a-4850-bbe4-14a6103c8525",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-2f7a-72d8-81c7-62322c0b442e.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with orange velvet sofas, a coffee table, a fireplace, and large windows.",
        "public_id": "019d20b0-2f7a-72d8-81c7-62322c0b442e",
        "storage_key": "property/6767906449165626/019d20b0-2f7a-72d8-81c7-62322c0b442e.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Spacious apartment living room with orange velvet sofas, a modern coffee table, a fireplace, and large windows with patterned curtains.",
      "link": "",
      "alt_text": "Living room in an apartment with orange velvet sofas, a coffee table, a fireplace, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-f31b-776c-92af-d480472ab626.webp"
    },
    {
      "id": "custom_cd59df44-bd47-4c4c-842e-55cfc97acdfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-30ce-750e-90b8-64cc51216e02.webp",
      "image_media": {
        "alt_text": "Bedroom with a wood-toned bed frame, matching nightstands, dresser, and a window with sheer white curtains.",
        "public_id": "019d20b0-30ce-750e-90b8-64cc51216e02",
        "storage_key": "property/6767906449165626/019d20b0-30ce-750e-90b8-64cc51216e02.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with matching light wood furniture, a green quilt, and warm bedside lighting.",
      "link": "",
      "alt_text": "Bedroom with a wood-toned bed frame, matching nightstands, dresser, and a window with sheer white curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-f608-759c-9728-66dbb2708e57.webp"
    },
    {
      "id": "custom_4583287f-c7be-49e1-a878-1cb512492447",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-37d3-700c-b6a8-951b3cfc38d6.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with marble countertop, sink, a large mirror, and a four-bulb light above.",
        "public_id": "019d20b0-37d3-700c-b6a8-951b3cfc38d6",
        "storage_key": "property/6767906449165626/019d20b0-37d3-700c-b6a8-951b3cfc38d6.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a dark vanity, marble countertop, large mirror, and bright lighting.",
      "link": "",
      "alt_text": "Bathroom vanity with marble countertop, sink, a large mirror, and a four-bulb light above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-f90c-7310-9015-feefef61aa17.webp"
    },
    {
      "id": "custom_15b46927-d4e8-4ee8-82d9-30f6e06e9c5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-3a43-717a-8608-442e396305b0.webp",
      "image_media": {
        "alt_text": "Bright living room with a sofa, glass coffee table, TV, and large windows with patterned curtains.",
        "public_id": "019d20b0-3a43-717a-8608-442e396305b0",
        "storage_key": "property/6767906449165626/019d20b0-3a43-717a-8608-442e396305b0.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Modern apartment living area with neutral tones, inviting seating, and abundant natural light.",
      "link": "",
      "alt_text": "Bright living room with a sofa, glass coffee table, TV, and large windows with patterned curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-fb5d-71d1-b87d-d514b762ac50.webp"
    },
    {
      "id": "custom_76ccc7c2-4f6f-49bb-987f-d292fc2c7ebf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-4007-7628-a7c9-81e8a58c9ee5.webp",
      "image_media": {
        "alt_text": "Open-concept living room with orange sofas, a wooden oval coffee table, and a modern kitchen island.",
        "public_id": "019d20b0-4007-7628-a7c9-81e8a58c9ee5",
        "storage_key": "property/6767906449165626/019d20b0-4007-7628-a7c9-81e8a58c9ee5.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Open-concept living space in a stylish apartment featuring orange upholstered seating, a round coffee table, and a modern kitchen island.",
      "link": "",
      "alt_text": "Open-concept living room with orange sofas, a wooden oval coffee table, and a modern kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-fd6f-735e-bcf4-95fdf947ea66.webp"
    },
    {
      "id": "custom_a44564d3-1ff7-4260-932c-3e72f369288c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-426f-7265-817e-7be152913c11.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with a marble countertop vanity, dark cabinets, mirror, and a pink shower curtain.",
        "public_id": "019d20b0-426f-7265-817e-7be152913c11",
        "storage_key": "property/6767906449165626/019d20b0-426f-7265-817e-7be152913c11.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Bright, modern apartment bathroom with marble vanity, dark cabinetry, and a pink shower curtain.",
      "link": "",
      "alt_text": "Bathroom in an apartment with a marble countertop vanity, dark cabinets, mirror, and a pink shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-fea5-7318-b9c7-02ca44052ad5.webp"
    },
    {
      "id": "custom_1ec1bf96-7b62-446f-8483-03096c606b04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-45cb-728f-8479-a2ca91daa667.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless-steel refrigerator, stove, microwave, and double sink.",
        "public_id": "019d20b0-45cb-728f-8479-a2ca91daa667",
        "storage_key": "property/6767906449165626/019d20b0-45cb-728f-8479-a2ca91daa667.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen with white cabinets, dark countertops, stainless-steel appliances, and coastal decor.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, stainless-steel refrigerator, stove, microwave, and double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb46-ff03-718f-9253-95f48cd8a619.webp"
    },
    {
      "id": "custom_8f20eccc-774a-4e22-b2d3-ee7365af62b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-4854-707d-a378-9c8a686edc51.webp",
      "image_media": {
        "alt_text": "Open-concept living area in a modern apartment: kitchen with island, dining table, and seating.",
        "public_id": "019d20b0-4854-707d-a378-9c8a686edc51",
        "storage_key": "property/6767906449165626/019d20b0-4854-707d-a378-9c8a686edc51.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Bright, open living space with a contemporary kitchen, island seating, and a dining area in a stylish apartment.",
      "link": "",
      "alt_text": "Open-concept living area in a modern apartment: kitchen with island, dining table, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-149e-7668-bbfa-99bd3fd9a324.webp"
    },
    {
      "id": "custom_51a69a17-281f-4421-903a-a0b854b5616f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-4ca8-77f1-a497-f49340406886.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with pink bedding, a wooden bed frame, and matching nightstands.",
        "public_id": "019d20b0-4ca8-77f1-a497-f49340406886",
        "storage_key": "property/6767906449165626/019d20b0-4ca8-77f1-a497-f49340406886.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Cozy bedroom in a modern multifamily unit with pink accents, wood furniture, and soft lighting.",
      "link": "",
      "alt_text": "Bedroom in an apartment with pink bedding, a wooden bed frame, and matching nightstands.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-01b6-7278-9816-8653b9408db9.webp"
    },
    {
      "id": "custom_ee63a0cb-1fd4-4f85-b15f-241135aafa11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-50ec-767b-aab8-666df6adc8f4.webp",
      "image_media": {
        "alt_text": "Living room in an apartment: gray sofa with pink cushions, white floral curtains, and a dining area.",
        "public_id": "019d20b0-50ec-767b-aab8-666df6adc8f4",
        "storage_key": "property/6767906449165626/019d20b0-50ec-767b-aab8-666df6adc8f4.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Spacious apartment living room with neutral tones, a gray sofa, pastel cushions, and a separate dining area.",
      "link": "",
      "alt_text": "Living room in an apartment: gray sofa with pink cushions, white floral curtains, and a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-1942-714e-8b8a-ca0554d38b51.webp"
    },
    {
      "id": "custom_61f77c2c-aa27-4b1f-a702-3ceb9febb137",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-5217-769f-af72-108685733308.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with white cabinets, stainless steel appliances, and a double sink.",
        "public_id": "019d20b0-5217-769f-af72-108685733308",
        "storage_key": "property/6767906449165626/019d20b0-5217-769f-af72-108685733308.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Sleek, fully equipped kitchen in a stylish apartment with white cabinetry, stainless steel appliances, and ample counter space.",
      "link": "",
      "alt_text": "Modern apartment kitchen with white cabinets, stainless steel appliances, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-0224-70cb-8881-880172b5cca3.webp"
    },
    {
      "id": "custom_56f88d2e-b975-443c-b4ca-026ad5281762",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-55cd-7682-8c34-b6a3da6f20c8.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with dark cabinets, stainless steel refrigerator, and marble-like countertops.",
        "public_id": "019d20b0-55cd-7682-8c34-b6a3da6f20c8",
        "storage_key": "property/6767906449165626/019d20b0-55cd-7682-8c34-b6a3da6f20c8.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Contemporary apartment kitchen featuring dark cabinetry, marble countertops, and stainless steel appliances.",
      "link": "",
      "alt_text": "Modern apartment kitchen with dark cabinets, stainless steel refrigerator, and marble-like countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-045e-725d-859c-2a4e6a65c39c.webp"
    },
    {
      "id": "custom_a6d04b7b-4cad-4348-a400-dac5f233ed21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-59a7-7101-91c5-2bac6f103b9b.webp",
      "image_media": {
        "alt_text": "Interior living area with round wood dining table, gray chairs, sofa, TV console, and decorative mirrors.",
        "public_id": "019d20b0-59a7-7101-91c5-2bac6f103b9b",
        "storage_key": "property/6767906449165626/019d20b0-59a7-7101-91c5-2bac6f103b9b.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Bright, modern living area in a multifamily community with a round dining table, neutral tones, and cozy seating.",
      "link": "",
      "alt_text": "Interior living area with round wood dining table, gray chairs, sofa, TV console, and decorative mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-06a1-72cc-a1cd-1a78328f0cf3.webp"
    },
    {
      "id": "custom_79fe7fcc-5cb5-4e52-8cf5-875e4093c491",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-5d9d-7371-97aa-53fa43a85be0.webp",
      "image_media": {
        "alt_text": "Kitchen in a modern apartment with dark cabinets, stainless-steel appliances, and marble countertops.",
        "public_id": "019d20b0-5d9d-7371-97aa-53fa43a85be0",
        "storage_key": "property/6767906449165626/019d20b0-5d9d-7371-97aa-53fa43a85be0.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Interior view of a contemporary apartment kitchen with dark cabinetry, stainless appliances, and marble-look countertops.",
      "link": "",
      "alt_text": "Kitchen in a modern apartment with dark cabinets, stainless-steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-0c86-709f-a2ff-c5e82073f3e6.webp"
    },
    {
      "id": "custom_78b886a8-9b8d-4a73-a221-1cf2eae47466",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-6095-75f1-a433-317d0c43a510.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with a single-sink vanity, large mirror, towels, and a floral-curtain shower.",
        "public_id": "019d20b0-6095-75f1-a433-317d0c43a510",
        "storage_key": "property/6767906449165626/019d20b0-6095-75f1-a433-317d0c43a510.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Apartment bathroom with a single-sink vanity, white cabinetry, a large mirror, and a floral-curtain shower.",
      "link": "",
      "alt_text": "Bathroom in an apartment with a single-sink vanity, large mirror, towels, and a floral-curtain shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-0e26-75d9-8168-64373b5b395a.webp"
    },
    {
      "id": "custom_bb8d33d9-827a-4a20-9c2b-cec7b701795c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-6301-72f6-9054-3aad4488dea6.webp",
      "image_media": {
        "alt_text": "Bathroom in apartment with tub/shower, white tiled walls, a patterned shower curtain, and a dark countertop vanity.",
        "public_id": "019d20b0-6301-72f6-9054-3aad4488dea6",
        "storage_key": "property/6767906449165626/019d20b0-6301-72f6-9054-3aad4488dea6.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a tub/shower, white tile surround, and a dark granite countertop vanity.",
      "link": "",
      "alt_text": "Bathroom in apartment with tub/shower, white tiled walls, a patterned shower curtain, and a dark countertop vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-1283-735d-be24-e18df255247b.webp"
    },
    {
      "id": "custom_f1e633cc-ecd9-45cb-9e9a-732cf445ed97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-65a7-75da-861a-9e6829fe2b3d.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, mirror, toilet, and tub/shower.",
        "public_id": "019d20b0-65a7-75da-861a-9e6829fe2b3d",
        "storage_key": "property/6767906449165626/019d20b0-65a7-75da-861a-9e6829fe2b3d.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a long vanity, white cabinetry, and a white-tiled shower/tub combo.",
      "link": "",
      "alt_text": "Bathroom with vanity, mirror, toilet, and tub/shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-1580-73de-b341-1a6cb8f61adf.webp"
    },
    {
      "id": "custom_89ca20e2-9cbb-4dc4-82d2-b5e3777d9723",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-6b6f-775b-820e-da39489da214.webp",
      "image_media": {
        "alt_text": "Modern living room in an apartment with a gray sofa, wall art, and a kitchen bar with stools.",
        "public_id": "019d20b0-6b6f-775b-820e-da39489da214",
        "storage_key": "property/6767906449165626/019d20b0-6b6f-775b-820e-da39489da214.webp",
        "width": 3072,
        "height": 2457
      },
      "title": "Apartment",
      "description": "Open living area in a modern apartment featuring a gray sofa, wall art, a coffee table, and a bar-height kitchen island.",
      "link": "",
      "alt_text": "Modern living room in an apartment with a gray sofa, wall art, and a kitchen bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-1c21-75f6-b933-2358e9560855.webp"
    },
    {
      "id": "custom_e84d8281-ad1a-4a2e-af68-c92e948e81f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-6c4c-72a0-80b6-11795ac39871.webp",
      "image_media": {
        "alt_text": "Living room in a modern apartment with orange sofas, a wall-mounted TV, and a fireplace.",
        "public_id": "019d20b0-6c4c-72a0-80b6-11795ac39871",
        "storage_key": "property/6767906449165626/019d20b0-6c4c-72a0-80b6-11795ac39871.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living room with contemporary furnishings, a fireplace, wall TV, and large windows for natural light.",
      "link": "",
      "alt_text": "Living room in a modern apartment with orange sofas, a wall-mounted TV, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-6d9c-7019-8aa2-c30a4fda637e.webp"
    },
    {
      "id": "custom_c7760998-a7a4-41ae-a4d0-91e457bdee91",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-6fbf-7304-a4a4-f820f4cdb046.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, marble countertops, and stainless steel appliances.",
        "public_id": "019d20b0-6fbf-7304-a4a4-f820f4cdb046",
        "storage_key": "property/6767906449165626/019d20b0-6fbf-7304-a4a4-f820f4cdb046.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Contemporary apartment kitchen with black cabinetry, marble countertops, and a stainless steel fridge.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, marble countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-6da8-739b-a2c2-778161fd93f1.webp"
    },
    {
      "id": "custom_518c429e-520d-45f7-be2d-772b12b79e9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-755a-777b-94d9-9107e71eafe3.webp",
      "image_media": {
        "alt_text": "Aerial cityscape of a downtown skyline with tall buildings and roads.",
        "public_id": "019d20b0-755a-777b-94d9-9107e71eafe3",
        "storage_key": "property/6767906449165626/019d20b0-755a-777b-94d9-9107e71eafe3.webp",
        "width": 1254,
        "height": 836
      },
      "title": "Lifestyle",
      "description": "Aerial view of a downtown skyline with high-rise buildings and a sprawling urban core.",
      "link": "",
      "alt_text": "Aerial cityscape of a downtown skyline with tall buildings and roads.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-7b48-7725-bad4-45be43d15002.webp"
    },
    {
      "id": "custom_ad93d361-8207-487a-87fb-13117c454218",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-77ec-716e-aa24-078cfa65ff31.webp",
      "image_media": {
        "alt_text": "Large white OKC letters on a grassy field with a Ferris wheel and city skyline in the background.",
        "public_id": "019d20b0-77ec-716e-aa24-078cfa65ff31",
        "storage_key": "property/6767906449165626/019d20b0-77ec-716e-aa24-078cfa65ff31.webp",
        "width": 1254,
        "height": 836
      },
      "title": "Lifestyle",
      "description": "Exterior signage featuring the OKC letters with a Ferris wheel and skyline in the background.",
      "link": "",
      "alt_text": "Large white OKC letters on a grassy field with a Ferris wheel and city skyline in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-7c80-73a8-a2f8-46058ad84043.webp"
    },
    {
      "id": "custom_b7870b85-01d9-4e92-8a6b-73fd88040e0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-7908-7354-818f-323d942eb325.webp",
      "image_media": {
        "alt_text": "Aerial cityscape at dusk with illuminated skyscrapers and a grid of lights.",
        "public_id": "019d20b0-7908-7354-818f-323d942eb325",
        "storage_key": "property/6767906449165626/019d20b0-7908-7354-818f-323d942eb325.webp",
        "width": 2000,
        "height": 650
      },
      "title": "Lifestyle",
      "description": "A wide aerial view of a lit downtown skyline at dusk, featuring tall towers and a vibrant city below.",
      "link": "",
      "alt_text": "Aerial cityscape at dusk with illuminated skyscrapers and a grid of lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-7f77-72dc-80b0-29452457878a.webp"
    },
    {
      "id": "custom_1d784c74-e995-458d-a4f8-a00b5fbd55c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-7a1e-708d-a015-35edd99fe40f.webp",
      "image_media": {
        "alt_text": "Close-up of a person’s hands holding a white travel mug beside a bicycle.",
        "public_id": "019d20b0-7a1e-708d-a015-35edd99fe40f",
        "storage_key": "property/6767906449165626/019d20b0-7a1e-708d-a015-35edd99fe40f.webp",
        "width": 698,
        "height": 797
      },
      "title": "Lifestyle",
      "description": "Lifestyle photo showing a person holding a travel mug beside a bicycle, conveying an active, outdoor vibe.",
      "link": "",
      "alt_text": "Close-up of a person’s hands holding a white travel mug beside a bicycle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-800a-7026-a7e1-bd0985069c63.webp"
    },
    {
      "id": "custom_8944a245-f840-4a11-b463-a8bf51e1a0e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-7cdf-771f-8bb6-42169d01687a.webp",
      "image_media": {
        "alt_text": "Children with backpacks boarding a yellow school bus outdoors.",
        "public_id": "019d20b0-7cdf-771f-8bb6-42169d01687a",
        "storage_key": "property/6767906449165626/019d20b0-7cdf-771f-8bb6-42169d01687a.webp",
        "width": 788,
        "height": 663
      },
      "title": "Lifestyle",
      "description": "Lifestyle photo of children with backpacks boarding a yellow school bus, conveying a family-friendly community vibe.",
      "link": "",
      "alt_text": "Children with backpacks boarding a yellow school bus outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-7fd6-723f-8144-e9c6db26833f.webp"
    },
    {
      "id": "custom_65c097a5-5245-42ff-8720-a6c7cc932342",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d20b0-7fb7-70dd-a848-a47b90dd39c6.webp",
      "image_media": {
        "alt_text": "Outdoor pedestrian plaza with brick storefronts, planters and pedestrians.",
        "public_id": "019d20b0-7fb7-70dd-a848-a47b90dd39c6",
        "storage_key": "property/6767906449165626/019d20b0-7fb7-70dd-a848-a47b90dd39c6.webp",
        "width": 788,
        "height": 469
      },
      "title": "Lifestyle",
      "description": "Sunlit plaza at a multifamily community with brick storefronts and shoppers.",
      "link": "",
      "alt_text": "Outdoor pedestrian plaza with brick storefronts, planters and pedestrians.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165626/019cfb47-85ac-772d-8adc-44bff2f33e86.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fa37c9ed-21f4-47c6-9fcf-25502c4d4cab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Topgolf Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "13313 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Entertainment venue blending technology, dining, and golf with a sports bar, and rooftop seating.",
      "poi_long_description": "People say this restaurant offers a fun atmosphere with games, kid clubs, and toddler clubs. They also highlight the affordable pricing, especially for groups, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-692c-716d-9d6a-ac6ed239b760.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-692c-716d-9d6a-ac6ed239b760",
        "storage_key": "property/6767906449165626/019d2709-692c-716d-9d6a-ac6ed239b760.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17880991546737991946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-oklahoma-city",
      "poi_latitude": "35.6027127",
      "poi_longitude": "-97.5351879",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-607-7154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9d23-7474-a0ae-04888516e8e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9d23-7474-a0ae-04888516e8e1",
        "storage_key": "property/6767906449165626/019d2709-9d23-7474-a0ae-04888516e8e1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0r8qRocsocRCqEU_xILJvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f67419b7-558a-49de-aa85-7b6b0e860694",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "8400 N Oklahoma Ave, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Bar with games such as pickleball and bocce and an on-site restaurant menu that encompasses wings to chicken sandwiches.",
      "poi_long_description": "People say this restaurant offers a fun day of pickleball, cornhole, drinks, and snacks. They also highlight the friendly staff, the perfect atmosphere for all ages, and the great experience for families and friends.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-69a9-701c-a077-3b6596cd1f37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-69a9-701c-a077-3b6596cd1f37",
        "storage_key": "property/6767906449165626/019d2709-69a9-701c-a077-3b6596cd1f37.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://chickennpickle.com/location/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4621211403201137082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---oklahoma-city",
      "poi_latitude": "35.5570464",
      "poi_longitude": "-97.5088888",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-839-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9d23-7474-a0ae-04888516e8e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9d23-7474-a0ae-04888516e8e1",
        "storage_key": "property/6767906449165626/019d2709-9d23-7474-a0ae-04888516e8e1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbbROHYZsocRusnJd0nXIUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2752aca1-8128-4a32-895e-6032e468828c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Main Event Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1441 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Family-friendly venue offering bowling, laser tag and arcade games, along with pizza and burgers, plus a ropes course.",
      "poi_long_description": "People say this restaurant offers a variety of fun games, including bowling, laser tag, and arcade games, and the pizza is great. They also highlight the friendly staff, the fun atmosphere, and the good drinks.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-6a37-745d-aeef-4f992a65c34c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6a37-745d-aeef-4f992a65c34c",
        "storage_key": "property/6767906449165626/019d2709-6a37-745d-aeef-4f992a65c34c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/oklahoma/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=10621058190493493742&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-oklahoma-city",
      "poi_latitude": "35.6102071",
      "poi_longitude": "-97.5381584",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-751-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9d23-7474-a0ae-04888516e8e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9d23-7474-a0ae-04888516e8e1",
        "storage_key": "property/6767906449165626/019d2709-9d23-7474-a0ae-04888516e8e1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bkHxccsocR7ikexyaUZZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7e731db6-512a-41b9-8fbc-e87549f70c8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2100 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain serving steaks and ribs in a casual setting featuring a jukebox and line dancers.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, chicken fried steak, and ribs, and the rolls with cinnamon butter are a highlight. They also highlight the friendly and accommodating staff, and the family-friendly atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-697e-7278-8d54-6b257dfb2454.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-697e-7278-8d54-6b257dfb2454",
        "storage_key": "property/6767906449165626/019d2709-697e-7278-8d54-6b257dfb2454.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-north-memorial-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3657567219942529703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.6078943",
      "poi_longitude": "-97.5503319",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-755-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9d23-7474-a0ae-04888516e8e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9d23-7474-a0ae-04888516e8e1",
        "storage_key": "property/6767906449165626/019d2709-9d23-7474-a0ae-04888516e8e1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYzghGscsocRp5rJBgJKwjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_6cff7d39-2b5c-4755-94d6-8764bd5833de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Clark Crew BBQ",
      "poi_type": "Restaurants",
      "poi_address": "3510 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Casual establishment with a patio for pit-smoked beef brisket, ribs, pulled pork and more.",
      "poi_long_description": "Diners say this barbecue restaurant serves up delicious burnt ends, brisket, ribs, and sausage, with sides of mac and cheese, baked beans, and cornbread. They also highlight the friendly and attentive service, and the lively back patio with live music.\n\nSome reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-6e4b-702f-a28e-ea28e8641bf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6e4b-702f-a28e-ea28e8641bf9",
        "storage_key": "property/6767906449165626/019d2709-6e4b-702f-a28e-ea28e8641bf9.webp",
        "width": 599,
        "height": 596
      },
      "poi_business_url": "http://www.clarkcrewbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3587788996052338906&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clark-crew-bbq",
      "poi_latitude": "35.5323986",
      "poi_longitude": "-97.5816496",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-724-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9d23-7474-a0ae-04888516e8e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9d23-7474-a0ae-04888516e8e1",
        "storage_key": "property/6767906449165626/019d2709-9d23-7474-a0ae-04888516e8e1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6r6_-4asocR2kjBPhVjyjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_21465637-3ef6-4a4d-a1e8-cb8c446aa4b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Quail Springs Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Shopping destination with a cinema, a food court, a kids' play area, and an arcade.",
      "poi_long_description": "People say this shopping center offers a variety of stores, a food court, a movie theater, and an arcade. They also highlight the fun atmosphere, the clean environment, and the good prices for the arcade and movies.\n\nOther reviews mention the food court can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-6e82-73ad-a410-51c9e322f159.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6e82-73ad-a410-51c9e322f159",
        "storage_key": "property/6767906449165626/019d2709-6e82-73ad-a410-51c9e322f159.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.quailspringsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=254102542958583292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quail-springs-mall",
      "poi_latitude": "35.6130282",
      "poi_longitude": "-97.5584437",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-254-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9d87-774c-8cc9-9f4ed20a8a57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9d87-774c-8cc9-9f4ed20a8a57",
        "storage_key": "property/6767906449165626/019d2709-9d87-774c-8cc9-9f4ed20a8a57.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR_N2RoerAhgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8cb4bf14-e0c4-422d-899c-3ec741e25a76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6409 Avondale Dr, Nichols Hills, OK 73116, USA",
      "poi_short_description": "Grocery chain featuring organic, gluten-free and vegan options, plus wine and flowers.",
      "poi_long_description": "People say this grocery store offers a wide selection of unique items, fresh produce, organic food, snacks, and wine. They highlight the affordable prices, good quality, and convenient pre-prepared meals. They also like the friendly staff and the pleasant, welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-6fdb-71a6-8f25-90b4b31ca4d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6fdb-71a6-8f25-90b4b31ca4d6",
        "storage_key": "property/6767906449165626/019d2709-6fdb-71a6-8f25-90b4b31ca4d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/nichols-hills/461/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6877173602117636080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "35.5376946",
      "poi_longitude": "-97.5310595",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-843-5655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9ce9-736a-bb45-7cb60e606426.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9ce9-736a-bb45-7cb60e606426",
        "storage_key": "property/6767906449165626/019d2709-9ce9-736a-bb45-7cb60e606426.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIaTG8SUasocR8E_qTPSgcF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c3d6745f-daaf-4f69-b21b-0eb4110a8b6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 N Western Ave, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Groceries, produce, artisan cheese and baked goods at a modern supermarket.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meats, cheeses, and baked goods, including many organic and vegan options. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-6f4a-777e-a86e-6649862d0544.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6f4a-777e-a86e-6649862d0544",
        "storage_key": "property/6767906449165626/019d2709-6f4a-777e-a86e-6649862d0544.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/oklahomacity?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=551365353270644661&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "35.5340444",
      "poi_longitude": "-97.5305342",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-879-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9ce9-736a-bb45-7cb60e606426.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9ce9-736a-bb45-7cb60e606426",
        "storage_key": "property/6767906449165626/019d2709-9ce9-736a-bb45-7cb60e606426.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkeF-rCYasocRtY8nF97Xpgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_22132322-82b5-457c-b07b-15636775e490",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2200 W 15th St #124, Edmond, OK 73013, USA",
      "poi_short_description": "Supermarket featuring aisles of fresh groceries, baked goods and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-72f0-766c-88e3-650fe4cc735d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-72f0-766c-88e3-650fe4cc735d",
        "storage_key": "property/6767906449165626/019d2709-72f0-766c-88e3-650fe4cc735d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9428274884093566538&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.6368691",
      "poi_longitude": "-97.5127608",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-330-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9ce9-736a-bb45-7cb60e606426.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9ce9-736a-bb45-7cb60e606426",
        "storage_key": "property/6767906449165626/019d2709-9ce9-736a-bb45-7cb60e606426.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSeJIYgesocRSl4izw3214I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_14766fd7-ae88-47af-8ea6-27c1d9628083",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "The Home Depot, 1901 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Home-improvement chain offering paint, tools, and building materials, plus installation services.",
      "poi_long_description": "People say this home improvement store has helpful and knowledgeable staff who are willing to assist with any task. They also highlight the friendly and efficient customer service, and the clean and well-stocked store.\n\nSome reviews mention the staff can be difficult to locate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-7338-70ca-b7a5-6fdf59246d67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7338-70ca-b7a5-6fdf59246d67",
        "storage_key": "property/6767906449165626/019d2709-7338-70ca-b7a5-6fdf59246d67.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Edmond/OK/Edmond/73013/3907?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5451913410994265011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.6346297",
      "poi_longitude": "-97.4849931",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-330-0151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9d87-774c-8cc9-9f4ed20a8a57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9d87-774c-8cc9-9f4ed20a8a57",
        "storage_key": "property/6767906449165626/019d2709-9d87-774c-8cc9-9f4ed20a8a57.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9xQ7Wf4esocRs1uAoFwWqUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_7b9c32b1-26e1-4962-bab9-298e3b935601",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "University of Central Oklahoma",
      "poi_type": "Education",
      "poi_address": "100 N University Dr, Edmond, OK 73034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-7415-71f1-acd6-8d31e1702613.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7415-71f1-acd6-8d31e1702613",
        "storage_key": "property/6767906449165626/019d2709-7415-71f1-acd6-8d31e1702613.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.uco.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17296425383341636856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-central-oklahoma",
      "poi_latitude": "35.657506",
      "poi_longitude": "-97.4709491",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 405-974-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9d4c-77dc-ae25-deffec7ce8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9d4c-77dc-ae25-deffec7ce8bb",
        "storage_key": "property/6767906449165626/019d2709-9d4c-77dc-ae25-deffec7ce8bb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvZ0xm_BNr4cR-Lwg6j4_CfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_56e724fa-f2cf-464c-b9da-135453c76260",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Oklahoma Christian University",
      "poi_type": "Education",
      "poi_address": "2501 E Memorial Rd, Edmond, OK 73013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-74da-73fc-b9bc-0d0f83a9a33c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-74da-73fc-b9bc-0d0f83a9a33c",
        "storage_key": "property/6767906449165626/019d2709-74da-73fc-b9bc-0d0f83a9a33c.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.oc.edu/?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907680163806340117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-christian-university",
      "poi_latitude": "35.6126232",
      "poi_longitude": "-97.4697937",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-425-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9d4c-77dc-ae25-deffec7ce8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9d4c-77dc-ae25-deffec7ce8bb",
        "storage_key": "property/6767906449165626/019d2709-9d4c-77dc-ae25-deffec7ce8bb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN68XpyQfsocRFWSwsYIC3V8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1fd995ff-7ef3-40e5-ac08-163baed92d44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Edmond Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "10 S Blvd, Edmond, OK 73034, USA",
      "poi_short_description": "Popular, kid-friendly facility offering books for all ages, magazines, music, movies, programs, computers and toy areas.",
      "poi_long_description": "People say this public library offers a huge selection of books, including online audio and e-books through the Libby app. They highlight the convenient self-checkout system, the ability to reserve books online, and the calm and clean atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-7797-759b-8a90-56267d8f935b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7797-759b-8a90-56267d8f935b",
        "storage_key": "property/6767906449165626/019d2709-7797-759b-8a90-56267d8f935b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=5308985467338173646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edmond-library---metropolitan-library-system",
      "poi_latitude": "35.6542015",
      "poi_longitude": "-97.4778675",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-341-9282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9d4c-77dc-ae25-deffec7ce8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9d4c-77dc-ae25-deffec7ce8bb",
        "storage_key": "property/6767906449165626/019d2709-9d4c-77dc-ae25-deffec7ce8bb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ73psmrMfsocRzixngidOrUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_6e46c7c7-f0bb-444c-b973-0732d977c764",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Blue Zoo Aquarium Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 125A, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Mall-based attraction featuring sharks, stingrays, snakes and other marine life plus a playground for kids.",
      "poi_long_description": "People say this aquarium offers a variety of interactive experiences, including stingray petting and feeding, bird feeding, and a mermaid show. They also highlight the family-friendly atmosphere, the friendly and helpful staff, and the fun play area for children.\n\nSome reviews mention the aquarium can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-780c-7159-b85a-2a2862a12a91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-780c-7159-b85a-2a2862a12a91",
        "storage_key": "property/6767906449165626/019d2709-780c-7159-b85a-2a2862a12a91.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oklahomacity.bluezoo.us/?utm_source=google&utm_medium=organic&utm_campaign=Google+Business+Profile+-+OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242468447430833348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-zoo-aquarium-oklahoma-city",
      "poi_latitude": "35.6125884",
      "poi_longitude": "-97.5573925",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 208-912-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4zKmxcdsocRxPRO80b9wEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_01f667a6-e359-42f1-95ea-1020988389b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Sky Zone",
      "poi_type": "Entertainment",
      "poi_address": "2525 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Children's entertainment center featuring indoor trampolines and other activities such as SkySlam basketball.",
      "poi_long_description": "People say this amusement park offers a fun trampoline park experience. They also highlight the friendly staff and management, and the clean and well-maintained facilities.\n\nOther reviews mention the price can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-78d9-7065-9219-b7e6cda8a81c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-78d9-7065-9219-b7e6cda8a81c",
        "storage_key": "property/6767906449165626/019d2709-78d9-7065-9219-b7e6cda8a81c.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "https://www.skyzone.com/edmond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11100529412539313541&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone",
      "poi_latitude": "35.6300623",
      "poi_longitude": "-97.4862479",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-359-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ75ZG2_wesocRhW0uBbAADZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_308af615-4dac-479a-9d47-f573223916b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Chad Richison Stadium",
      "poi_type": "Entertainment",
      "poi_address": "100 E University Dr, Edmond, OK 73034, USA",
      "poi_short_description": "High school stadium hosting football games, including state championship events.",
      "poi_long_description": "People say this stadium offers a great experience for watching soccer games. They highlight the facilities are clean and well-maintained, and the sound system is top-notch. They also like the wide variety of concession options and the convenient credit card acceptance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-79ca-73c9-afef-1c15faad4eb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-79ca-73c9-afef-1c15faad4eb7",
        "storage_key": "property/6767906449165626/019d2709-79ca-73c9-afef-1c15faad4eb7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bronchosports.com/sports/2011/6/10/FB_0610111744.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10132052462898693569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chad-richison-stadium",
      "poi_latitude": "35.6615051",
      "poi_longitude": "-97.4707673",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 405-974-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a165-762f-ab8b-62186731428d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a165-762f-ab8b-62186731428d",
        "storage_key": "property/6767906449165626/019d2709-a165-762f-ab8b-62186731428d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhdKbbbcfsocRwcWyeAhInIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_d80afad7-bd85-4a64-909b-169c4879602b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Edmond History Museum",
      "poi_type": "Entertainment",
      "poi_address": "431 S Blvd, Edmond, OK 73034, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this museum offers a variety of displays and hands-on activities, especially for children. They highlight the fun role-play activities and the interesting local facts for adults. They also like the friendly staff and the free admission with the option of a gift shop and donation box.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-7c63-77a5-aa8c-23696151d4b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7c63-77a5-aa8c-23696151d4b6",
        "storage_key": "property/6767906449165626/019d2709-7c63-77a5-aa8c-23696151d4b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.edmondhistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=107138316684570186&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edmond-history-museum",
      "poi_latitude": "35.650103",
      "poi_longitude": "-97.4784",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-340-0078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a19c-708f-a3a2-400fbeddd0b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a19c-708f-a3a2-400fbeddd0b6",
        "storage_key": "property/6767906449165626/019d2709-a19c-708f-a3a2-400fbeddd0b6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJy3Bcga0fsocRSi7RO7uhfAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_34695094-140b-423b-a55a-065aee9f8f9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Dobson Field",
      "poi_type": "Entertainment",
      "poi_address": "Baird Loop, Edmond, OK 73013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-7c8d-71bd-adcd-d750d171ae38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7c8d-71bd-adcd-d750d171ae38",
        "storage_key": "property/6767906449165626/019d2709-7c8d-71bd-adcd-d750d171ae38.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9132438859912438972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dobson-field",
      "poi_latitude": "35.6139766",
      "poi_longitude": "-97.4731539",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a165-762f-ab8b-62186731428d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a165-762f-ab8b-62186731428d",
        "storage_key": "property/6767906449165626/019d2709-a165-762f-ab8b-62186731428d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn_Ha_3IfsocRvOQN4sHwvH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_58c2e954-b154-4f2b-974e-69b65184556b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Mitch Park YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2901 Marilyn Williams Dr, Edmond, OK 73003, USA",
      "poi_short_description": "Clean sports facility featuring a fitness center and an outdoor track, as well as an indoor pool, disc golf and basketball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-7e5a-7198-aede-023ca81c5570.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7e5a-7198-aede-023ca81c5570",
        "storage_key": "property/6767906449165626/019d2709-7e5a-7198-aede-023ca81c5570.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ymcaokc.org/branches/mitch-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15994863836961186949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitch-park-ymca",
      "poi_latitude": "35.6847017",
      "poi_longitude": "-97.5083114",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-330-4016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-eeHJvT1sYcRhSTQUOor-d0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_65a7e7a0-ab95-4d88-904a-80eb7472b242",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "2563 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers excellent tennis courts. They also highlight the facility has many pools and pickleball courts.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-7e74-73da-a664-b4bd741dba3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7e74-73da-a664-b4bd741dba3d",
        "storage_key": "property/6767906449165626/019d2709-7e74-73da-a664-b4bd741dba3d.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/oklahoma-city.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614994550085944548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "35.61423510000001",
      "poi_longitude": "-97.5602129",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-832-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWAnM3kdsocR5ITAcGgt8rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_07ef4e1b-ef44-4b50-87a3-e98ac0715a39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of group fitness classes, modern equipment, and childcare, and has a friendly and motivating atmosphere.\n\nOther reviews mention membership cancellation can be difficult and there can be hidden fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-814b-77f2-8932-a076d6ea5d85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-814b-77f2-8932-a076d6ea5d85",
        "storage_key": "property/6767906449165626/019d2709-814b-77f2-8932-a076d6ea5d85.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city-ok",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_819ed99e-9b87-4adf-ab41-ec6950c5c3f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Oklahoma Gold Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 Technology Dr, Edmond, OK 73013, USA",
      "poi_short_description": "Gym for kids offering classes in gymnastics and tumbling, plus birthday parties.",
      "poi_long_description": "People say this gymnastics center offers fun classes and birthday parties for young children. They highlight the positive and encouraging atmosphere, and the confidence children gain. They also like the kind, welcoming, and dedicated staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-8266-7365-b8c3-21f6bdf7d742.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8266-7365-b8c3-21f6bdf7d742",
        "storage_key": "property/6767906449165626/019d2709-8266-7365-b8c3-21f6bdf7d742.webp",
        "width": 1280,
        "height": 775
      },
      "poi_business_url": "http://www.oklahomagoldgymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=191096937127623553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-gold-gymnastics",
      "poi_latitude": "35.6263031",
      "poi_longitude": "-97.4926773",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-341-1175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9d4c-77dc-ae25-deffec7ce8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9d4c-77dc-ae25-deffec7ce8bb",
        "storage_key": "property/6767906449165626/019d2709-9d4c-77dc-ae25-deffec7ce8bb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw7GpO_AesocRgTso36bppgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_960cbf2a-32d4-48e4-8c36-d264f978b7b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Crunch Fitness - Edmond",
      "poi_type": "Health and Wellness",
      "poi_address": "2121 W Danforth Rd, Edmond, OK 73003, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, cardio machines, and powerlifting stations, and has a spacious layout with an outdoor workout area.\n\nOther reviews mention the restrooms can be poorly maintained and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-83c8-74ad-aa8c-ca087a908ff3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-83c8-74ad-aa8c-ca087a908ff3",
        "storage_key": "property/6767906449165626/019d2709-83c8-74ad-aa8c-ca087a908ff3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/edmond",
      "poi_directions_map_url": "https://maps.google.com/?cid=8462207099918585172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---edmond",
      "poi_latitude": "35.6692665",
      "poi_longitude": "-97.5106805",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-920-1940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1bUEHcfsocRVI1vzoXMb3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_293bf5c4-5e4a-4035-b397-4adc1c975093",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2209 W Edmond Rd, Edmond, OK 73003, USA",
      "poi_short_description": "Laid-back fitness center featuring workout machines plus massage chairs and tanning beds.",
      "poi_long_description": "People say this gym offers a good selection of equipment and machines, including free weights and tanning beds. They highlight the clean and tidy facility, and the convenient location and hours. They also like the friendly and helpful staff, and the welcoming and non-judgmental atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-842f-775c-9937-fa8290c53da7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-842f-775c-9937-fa8290c53da7",
        "storage_key": "property/6767906449165626/019d2709-842f-775c-9937-fa8290c53da7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/edmond-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12798186502624872755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.6543154",
      "poi_longitude": "-97.5129943",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-697-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu4H7420esocRM4knAtFKnLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_252fa875-fbdd-4711-adb2-3a3e97f69d28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "TB Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-865f-7277-a3e6-3211baba2ea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-865f-7277-a3e6-3211baba2ea4",
        "storage_key": "property/6767906449165626/019d2709-865f-7277-a3e6-3211baba2ea4.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fitness-club",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5318e8df-f7d1-4eeb-b480-ae08f9cd11fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Metro Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "7420 Broadway Ext, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Gymnastics center offering classes and birthday parties for kids of various ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-8808-70f4-8f4a-21d0b8b653c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8808-70f4-8f4a-21d0b8b653c6",
        "storage_key": "property/6767906449165626/019d2709-8808-70f4-8f4a-21d0b8b653c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrogymokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3312655711320854520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-gymnastics",
      "poi_latitude": "35.5464292",
      "poi_longitude": "-97.5132581",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-848-5308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9d4c-77dc-ae25-deffec7ce8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9d4c-77dc-ae25-deffec7ce8bb",
        "storage_key": "property/6767906449165626/019d2709-9d4c-77dc-ae25-deffec7ce8bb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSXSRwJwZsocR-M9yeNHq-C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1713b249-8da7-4699-9c41-b0a2533f1557",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "2340 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Beauty retailer offering cosmetics, fragrances, and skin and hair care products, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-889e-75c8-8b91-b528c3b3924b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-889e-75c8-8b91-b528c3b3924b",
        "storage_key": "property/6767906449165626/019d2709-889e-75c8-8b91-b528c3b3924b.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/oklahoma-city-ok-128",
      "poi_directions_map_url": "https://maps.google.com/?cid=17751417342740012859&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.606929",
      "poi_longitude": "-97.553605",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-302-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmaQHR2kcsocROx-6rQW0WfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_f1f4392e-90e3-4dc5-8e07-b05d3f4482ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-8903-76f6-a92a-cb0ba2b5df4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8903-76f6-a92a-cb0ba2b5df4c",
        "storage_key": "property/6767906449165626/019d2709-8903-76f6-a92a-cb0ba2b5df4c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a187-722a-be8a-a73aa1ca8039.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a187-722a-be8a-a73aa1ca8039",
        "storage_key": "property/6767906449165626/019d2709-a187-722a-be8a-a73aa1ca8039.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0c4886db-13e2-4d21-8a54-680d737b4c52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-8a99-7228-b704-f771cc5c6639.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8a99-7228-b704-f771cc5c6639",
        "storage_key": "property/6767906449165626/019d2709-8a99-7228-b704-f771cc5c6639.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baptist.integrisok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a187-722a-be8a-a73aa1ca8039.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a187-722a-be8a-a73aa1ca8039",
        "storage_key": "property/6767906449165626/019d2709-a187-722a-be8a-a73aa1ca8039.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_209bfaaa-0acc-4158-9b8a-dfdefbacdf93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Kid-friendly nature preserve with playgrounds and trails, plus deer and turtles.",
      "poi_long_description": "People say this park offers beautiful trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the serene and peaceful atmosphere, and the well-maintained grounds. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-8ce8-73d9-84e3-73b080b0e648.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8ce8-73d9-84e3-73b080b0e648",
        "storage_key": "property/6767906449165626/019d2709-8ce8-73d9-84e3-73b080b0e648.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a587-71c9-8baf-0bd9baab193b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a587-71c9-8baf-0bd9baab193b",
        "storage_key": "property/6767906449165626/019d2709-a587-71c9-8baf-0bd9baab193b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bebab388-a945-49a6-94ae-fe56cbf67c9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Stars And Stripes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3701 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Relaxed, family-friendly park bordering Lake Hefner offering a skatepark, plus playgrounds.",
      "poi_long_description": "People say this city park offers a large playground, walking trails, and panoramic views of the lake. They highlight the numerous play areas, tables, and BBQ spaces, as well as the decent parking and proximity to the lake. They also like the ability to build sandcastles and watch boats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-8e14-73a0-99f5-164d90b28b35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8e14-73a0-99f5-164d90b28b35",
        "storage_key": "property/6767906449165626/019d2709-8e14-73a0-99f5-164d90b28b35.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/34/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=16012526237037472583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stars-and-stripes-park",
      "poi_latitude": "35.5500436",
      "poi_longitude": "-97.5822759",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a587-71c9-8baf-0bd9baab193b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a587-71c9-8baf-0bd9baab193b",
        "storage_key": "property/6767906449165626/019d2709-a587-71c9-8baf-0bd9baab193b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2tmaBwbsocRR6s9S8brN94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_96a334e2-5dfd-46ba-9524-9b45a34cd367",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Bluff Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11301 N Meridian Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "A large green space featuring walking trails, picnic spots and a playground.",
      "poi_long_description": "Visitors say this park offers well-maintained walking trails, paved trails, and bike trails, and they praise the abundance of wildlife, especially deer. They also highlight the peaceful atmosphere, ideal for nature walks, jogging, or simply relaxing in the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-8f84-770a-8cbd-ed9d90c868db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8f84-770a-8cbd-ed9d90c868db",
        "storage_key": "property/6767906449165626/019d2709-8f84-770a-8cbd-ed9d90c868db.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1559565554729670411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluff-creek-park",
      "poi_latitude": "35.584442",
      "poi_longitude": "-97.6065873",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-837-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a587-71c9-8baf-0bd9baab193b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a587-71c9-8baf-0bd9baab193b",
        "storage_key": "property/6767906449165626/019d2709-a587-71c9-8baf-0bd9baab193b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zaRlYbsocRC9eY7ZuwpBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f80d58ba-1861-4c5f-8185-41fae69e57de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Rose Creek Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17031 N May Ave, Edmond, OK 73012, USA",
      "poi_short_description": "Private golf course with an on-site eatery, pickleball courts, a clubhouse and a patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-8f80-756b-857c-68e69ab8576c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8f80-756b-857c-68e69ab8576c",
        "storage_key": "property/6767906449165626/019d2709-8f80-756b-857c-68e69ab8576c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rosecreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897560691660009268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-creek-country-club",
      "poi_latitude": "35.6449907",
      "poi_longitude": "-97.5686808",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-330-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a563-721e-ba39-6b4160b43753.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a563-721e-ba39-6b4160b43753",
        "storage_key": "property/6767906449165626/019d2709-a563-721e-ba39-6b4160b43753.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8IOAwgdsocRNK83toTEvs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_e6cfbb7c-7296-4f49-8cd8-2432cd3c60bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Mitch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Edmond, OK 73003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-924f-759e-88db-27c01f7719a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-924f-759e-88db-27c01f7719a2",
        "storage_key": "property/6767906449165626/019d2709-924f-759e-88db-27c01f7719a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.edmondok.gov/facilities/facility/details/Mitch-Park-19",
      "poi_directions_map_url": "https://maps.google.com/?cid=1740714302256427325&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitch-park",
      "poi_latitude": "35.6826377",
      "poi_longitude": "-97.5065914",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a587-71c9-8baf-0bd9baab193b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a587-71c9-8baf-0bd9baab193b",
        "storage_key": "property/6767906449165626/019d2709-a587-71c9-8baf-0bd9baab193b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfU7CegD1sYcRPbFvaW9CKBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_360f14b0-e8a9-4bd1-b5bf-be4b7667dd2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-943d-7275-8892-431d0fa3005b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-943d-7275-8892-431d0fa3005b",
        "storage_key": "property/6767906449165626/019d2709-943d-7275-8892-431d0fa3005b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6afdbbfd-682e-40f4-83ee-4d548ade6365",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Chesapeake Energy Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6100 N Western Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9507-752d-b807-be2ed381543a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9507-752d-b807-be2ed381543a",
        "storage_key": "property/6767906449165626/019d2709-9507-752d-b807-be2ed381543a.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.expandenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3999976576566005612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chesapeake-energy-corporation",
      "poi_latitude": "35.5346273",
      "poi_longitude": "-97.5289016",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-848-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8cjlSYasocRbI8Z7IDFgjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1c3d59ca-813e-4be8-a76b-ce8b4a9b3ba3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-9455-7233-9f56-87f983ee7f7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9455-7233-9f56-87f983ee7f7a",
        "storage_key": "property/6767906449165626/019d2709-9455-7233-9f56-87f983ee7f7a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a0b25ac3-788a-4169-aeff-835e78ae46e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Love's Corporate - Building 50",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3601 NW 63rd St, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-98d7-72c2-b1aa-0c12a0063a51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-98d7-72c2-b1aa-0c12a0063a51",
        "storage_key": "property/6767906449165626/019d2709-98d7-72c2-b1aa-0c12a0063a51.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4599439798442847940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---building-50",
      "poi_latitude": "35.5374849",
      "poi_longitude": "-97.5809021",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8bq4uQasocRxO76tyB-1D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_da319350-1eee-4f74-ace1-709421fe6162",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Love's Corporate - Contact Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1331 W Memorial Rd Suite 100, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-98a0-706c-82f2-d723a227a8be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-98a0-706c-82f2-d723a227a8be",
        "storage_key": "property/6767906449165626/019d2709-98a0-706c-82f2-d723a227a8be.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "http://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980310977560095404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---contact-center",
      "poi_latitude": "35.61081310000001",
      "poi_longitude": "-97.5351028",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e2-72ea-a423-23f048f7a9cb",
        "storage_key": "property/6767906449165626/019d2709-a0e2-72ea-a423-23f048f7a9cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKbub2xkcsocRrKpygHKeHUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_85f1de9b-ac1c-4575-b277-46509d1af0a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Stonegate Elementary School",
      "poi_type": "Education",
      "poi_address": "2525 NW 112th St, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12482700057558395251&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stonegate-elementary-school",
      "poi_latitude": "35.5841914",
      "poi_longitude": "-97.5603553",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-751-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-e9f6719824fc",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl-70QIQbsocRcymE8JB1O60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ab8e3e9b-15d4-4343-ad34-cbbcf3924181",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Britton Elementary School",
      "poi_type": "Education",
      "poi_address": "1215 NW 95th St, Oklahoma City, OK 73114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.okcps.org/britton",
      "poi_directions_map_url": "https://maps.google.com/?cid=176711978193733250&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "britton-elementary-school",
      "poi_latitude": "35.5676577",
      "poi_longitude": "-97.534546",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-587-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-e9f6719824fc",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ44LZ5dwbsocRgkbLn5vOcwI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2faf3adc-0dea-478c-8245-846000d00792",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Summit Middle School",
      "poi_type": "Education",
      "poi_address": "1703 NW 150th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-0eaf-7262-b5bd-00ecb7a7f65c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0eaf-7262-b5bd-00ecb7a7f65c",
        "storage_key": "property/6767906449165626/019d7913-0eaf-7262-b5bd-00ecb7a7f65c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://summit.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4052681169359623432&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "summit-middle-school",
      "poi_latitude": "35.625296",
      "poi_longitude": "-97.5414836",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-340-2920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-e9f6719824fc",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJueUCwjkcsocRCFWYLw0EPjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_12ea2ad1-3436-4390-bf44-930e99b2d206",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "John Marshall Middle School",
      "poi_type": "Education",
      "poi_address": "2401 NW 115th Terrace, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-0f6b-766b-a671-aa713f8e35c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0f6b-766b-a671-aa713f8e35c2",
        "storage_key": "property/6767906449165626/019d7913-0f6b-766b-a671-aa713f8e35c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okcps.org/Domain/24",
      "poi_directions_map_url": "https://maps.google.com/?cid=12695469249844632585&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "john-marshall-middle-school",
      "poi_latitude": "35.5881777",
      "poi_longitude": "-97.5562916",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-587-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-e9f6719824fc",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm0t9k4gbsocRCVzi7QReL7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6867fa1e-abc2-482b-a4e5-10ed48b50da6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Heritage Hall",
      "poi_type": "Education",
      "poi_address": "1800 NW 122nd St, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-0eb9-7790-ac6d-b95dbf105818.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0eb9-7790-ac6d-b95dbf105818",
        "storage_key": "property/6767906449165626/019d7913-0eb9-7790-ac6d-b95dbf105818.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.heritagehall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7233749162249664118&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "heritage-hall",
      "poi_latitude": "35.591122",
      "poi_longitude": "-97.542737",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-749-3001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-e9f6719824fc",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp_UYSwgcsocRdrYreolwY2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_46afef1f-c598-447c-a596-64f6cb68f4b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Mercy School Institute",
      "poi_type": "Education",
      "poi_address": "14001 N Harvey Ave, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-0eae-70ef-9626-d972aa3fd071.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0eae-70ef-9626-d972aa3fd071",
        "storage_key": "property/6767906449165626/019d7913-0eae-70ef-9626-d972aa3fd071.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "http://www.mercyschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11702466736219190867&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mercy-school-institute",
      "poi_latitude": "35.6127046",
      "poi_longitude": "-97.5190585",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-748-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-e9f6719824fc",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEZOm26MesocRU3YriH6DZ6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_2ef7f0e5-7893-41ae-bbf5-4b1c08775e3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "John Marshall High School",
      "poi_type": "Education",
      "poi_address": "12201 Portland Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-197f-7396-8eb8-b3dcce58fc88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-197f-7396-8eb8-b3dcce58fc88",
        "storage_key": "property/6767906449165626/019d7913-197f-7396-8eb8-b3dcce58fc88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okcps.org/Johnmarshall",
      "poi_directions_map_url": "https://maps.google.com/?cid=13761330892857833865&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "john-marshall-high-school",
      "poi_latitude": "35.5932637",
      "poi_longitude": "-97.5882344",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-587-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-e9f6719824fc",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnV-lOJ8csocRiXlmUYkR-r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_61e80607-d8cb-4d2b-98a6-8d81525593aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Central Oklahoma College",
      "poi_type": "Education",
      "poi_address": "14820 Serenita Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-1629-77d9-ab79-a069ef8b50da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-1629-77d9-ab79-a069ef8b50da",
        "storage_key": "property/6767906449165626/019d7913-1629-77d9-ab79-a069ef8b50da.webp",
        "width": 1280,
        "height": 758
      },
      "poi_business_url": "http://www.centraloc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17937297259247166320&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "central-oklahoma-college",
      "poi_latitude": "35.6214379",
      "poi_longitude": "-97.5602012",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-609-6622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-e9f6719824fc",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvTWsrm8EsocRcOMDSNIU7vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_35d05225-1bb7-4edf-af28-8444445d6da0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Francis Tuttle Technology Center - Portland Campus",
      "poi_type": "Education",
      "poi_address": "3500 NW 150th St, Oklahoma City, OK 73134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-40a6-700d-a859-99783b1064fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-40a6-700d-a859-99783b1064fd",
        "storage_key": "property/6767906449165626/019d7913-40a6-700d-a859-99783b1064fd.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "https://www.francistuttle.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2702707263909702839&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "francis-tuttle-technology-center-portland-campus",
      "poi_latitude": "35.622262",
      "poi_longitude": "-97.582605",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-717-7799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-e9f6719824fc",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-e9f6719824fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoRKGieUcsocRt6w03e_xgSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_d3e584b4-2b1f-4a30-98b0-d1a117083729",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Opus Prime Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "800 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Elegant steakhouse with a full bar & patio offering dry-aged prime beef, seafood & a vast wine list.",
      "poi_long_description": "Diners say this steak house serves up fantastic steaks, including ribeye and wagyu, and delicious lobster mac and cheese. They also highlight the excellent service and the warm, tasty bread.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-26ea-76ac-89d4-3ad2bc933f9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-26ea-76ac-89d4-3ad2bc933f9d",
        "storage_key": "property/6767906449165626/019d7913-26ea-76ac-89d4-3ad2bc933f9d.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://opusprimesteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15668684757345628192&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "opus-prime-steakhouse",
      "poi_latitude": "35.6086003",
      "poi_longitude": "-97.5281249",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-607-6787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-eecf949f56c4",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqUSZOhwcsocRIPApQ8VZctk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_38700e90-e151-4794-8e6f-23cd3c3aa4f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Symmetry",
      "poi_type": "Restaurants",
      "poi_address": "9203 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this steakhouse serves delicious steaks, including filet mignon and prime ribeye, and offers a variety of sides, such as mac and cheese and mashed potatoes. They highlight the cozy and chic atmosphere, and the professional and attentive staff. They also like the good drinks and the special touches for celebrations, such as anniversary cards.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-28ec-73ff-8489-7f7f5e96e45b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-28ec-73ff-8489-7f7f5e96e45b",
        "storage_key": "property/6767906449165626/019d7913-28ec-73ff-8489-7f7f5e96e45b.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://symmetrydining.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5225803636304341466&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "symmetry",
      "poi_latitude": "35.5637524",
      "poi_longitude": "-97.5494779",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-849-4550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-eecf949f56c4",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6paL7kbsocR2mndP7jIhUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_301adcbf-73fa-475f-9b73-c37e7dc55b47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Redrock Canyon Grill",
      "poi_type": "Restaurants",
      "poi_address": "9221 Lake Hefner Pkwy, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Easygoing bistro & bar turning out wood-fired rotisserie chicken & Southwest-inspired dishes.",
      "poi_long_description": "People say this American restaurant serves delicious roasted chicken, filet, and ribs, and the house salad with cornbread croutons is a highlight. They highlight the beautiful lake views, especially at sunset, and the lively, upbeat atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-6262-74ba-8be8-85791c2b6c4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6262-74ba-8be8-85791c2b6c4d",
        "storage_key": "property/6767906449165626/019d7913-6262-74ba-8be8-85791c2b6c4d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.redrockcanyongrill.com/locations/redrock-canyon-grill-okc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18024707086159946252&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "redrock-canyon-grill",
      "poi_latitude": "35.5637167",
      "poi_longitude": "-97.5781056",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-749-1995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-eecf949f56c4",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f3w5AsbsocRDKIHi5ifJPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_6e0950a4-62c6-4bcc-8d50-38bd5457635b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Gabriella's Italian Grill & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3601 S Broadway Ste 600, Edmond, OK 73013, USA",
      "poi_short_description": "Chef-owned eatery crafting refined homestyle Italian cuisine in a relaxed, family-friendly ambiance.",
      "poi_long_description": "People say this Italian restaurant serves delicious pasta, pizza, and other Italian dishes. They also highlight the authentic ingredients, family atmosphere, and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-3133-7758-b012-549acdafb9df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3133-7758-b012-549acdafb9df",
        "storage_key": "property/6767906449165626/019d7913-3133-7758-b012-549acdafb9df.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gabriellasokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6000322265861139267&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gabriella-s-italian-grill-pizzeria",
      "poi_latitude": "35.619277",
      "poi_longitude": "-97.4906807",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-478-4955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-eecf949f56c4",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_PxPrEZsocRQyuFSk9tRVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_ae69ba2c-0b53-4803-8703-d8a736337e34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Michael's Grill",
      "poi_type": "Restaurants",
      "poi_address": "2824 W Country Club Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Traditional restaurant offering lobster tails, caesar salads & steaks, along with wine & cocktails.",
      "poi_long_description": "Traditional restaurant offering lobster tails, caesar salads & steaks, along with wine & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-2e3b-7355-bc8e-c6809d4676e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2e3b-7355-bc8e-c6809d4676e7",
        "storage_key": "property/6767906449165626/019d7913-2e3b-7355-bc8e-c6809d4676e7.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://michaelsgrillokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14432248066412458593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "michael-s-grill",
      "poi_latitude": "35.5469191",
      "poi_longitude": "-97.564716",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-810-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-eecf949f56c4",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7RqM6sbsocRYTLVrCalScg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1a759221-4825-452e-87cb-6a316f53da83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Ember Modern American Tavern",
      "poi_type": "Restaurants",
      "poi_address": "at Renaissance Waterford Oklahoma City Hotel, 6300 Waterford Blvd, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Comfortable American restaurant and bar offering breakfast, lunch, dinner, and a buffet.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-3703-71ab-b4ec-6a3aebb72889.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3703-71ab-b4ec-6a3aebb72889",
        "storage_key": "property/6767906449165626/019d7913-3703-71ab-b4ec-6a3aebb72889.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3810949209892319010&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ember-modern-american-tavern",
      "poi_latitude": "35.5347301",
      "poi_longitude": "-97.544992",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-858-2490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-eecf949f56c4",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzzXnXzgasocRIu-veB024zQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e0d0d5d7-7cae-4601-8fe9-416a1da26e77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "The Metro Wine Bar & Bistro",
      "poi_type": "Restaurants",
      "poi_address": "6418 N Western Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "A cozy dimly lit establishment featuring French-inspired cuisine, cocktails & 400+ wines.",
      "poi_long_description": "People say this restaurant offers delicious dishes like parmesan risotto, mushroom ravioli, and cedar-planked salmon, as well as thoughtfully crafted mocktails and expertly paired wine flights. They highlight the sophisticated yet comfortable ambiance, perfect for special occasions or a relaxing night out. They also like the attentive, knowledgeable, and welcoming service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-39d4-73cb-852d-29ce8a3c6d4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-39d4-73cb-852d-29ce8a3c6d4f",
        "storage_key": "property/6767906449165626/019d7913-39d4-73cb-852d-29ce8a3c6d4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrowinebar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12574017624860625019&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-metro-wine-bar-bistro",
      "poi_latitude": "35.5376496",
      "poi_longitude": "-97.5293252",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-840-9463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-eecf949f56c4",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TqhDCYasocRe4hR6Wjif64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_92107d2d-f9c3-46af-8f0c-2548cb04e97e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Ranch Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "3000 W Britton Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Upscale dining in a large, stately venue exhibiting fine art from the Western Heritage Museum.",
      "poi_long_description": "People say this steakhouse serves delicious ribeye, filet, and sirloin steaks, cooked to perfection. They highlight the elegant atmosphere, attentive service, and generous portions. They also like the knowledgeable and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-4314-7709-b31a-c2198bc56a60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4314-7709-b31a-c2198bc56a60",
        "storage_key": "property/6767906449165626/019d7913-4314-7709-b31a-c2198bc56a60.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ranchsteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9330039975159806164&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ranch-steakhouse",
      "poi_latitude": "35.5648778",
      "poi_longitude": "-97.5694556",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-755-3501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae4-77e2-9492-eecf949f56c4",
        "storage_key": "property/6767906449165626/019cfb47-bae4-77e2-9492-eecf949f56c4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN55-QgobsocR1DiYu-z1eoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_0c26ddc1-ba52-447b-868a-e2f21dfb25c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Department store carrying a wide range of merchandise, including electronics, home appliances, and groceries.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, home goods, and electronics, and provides convenient services like delivery and online pickup.\n\nOther reviews mention the service can be slow and the store can be understaffed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-4c02-70dd-89f8-81bb8ba6da32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4c02-70dd-89f8-81bb8ba6da32",
        "storage_key": "property/6767906449165626/019d7913-4c02-70dd-89f8-81bb8ba6da32.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1626-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10140810101618845328&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.6052952",
      "poi_longitude": "-97.5460685",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-752-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-baeb-706e-b972-dc0f3a4634a2",
        "storage_key": "property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-WNQUWscsocRkCavIQ9lu4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_90d6f680-da69-4daa-8b29-0becae63b7a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Norwalk Furniture & Design",
      "poi_type": "Shopping & Retail",
      "poi_address": "12100 N May Ave suite d, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-57cd-761e-8fd4-c376af50f2c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-57cd-761e-8fd4-c376af50f2c2",
        "storage_key": "property/6767906449165626/019d7913-57cd-761e-8fd4-c376af50f2c2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.norwalkfurnitureokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17870737357739441154&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "norwalk-furniture-design",
      "poi_latitude": "35.5929081",
      "poi_longitude": "-97.5661921",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-748-5774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-baeb-706e-b972-dc0f3a4634a2",
        "storage_key": "property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU0-WkH8csocRArxckvGcAfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_afcf237c-7f90-45e9-8ea5-3c52426fe06d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Von Maur",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 West Memorial Road Quail Springs Mall, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Department-store chain stocking brand-name clothing, jewelry & home accessories.",
      "poi_long_description": "People say this department store offers a wide selection of products. They also highlight the elegant and beautiful ambiance, and the live pianist adds a touch of class.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-5870-74f1-bdec-9670183bddc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5870-74f1-bdec-9670183bddc2",
        "storage_key": "property/6767906449165626/019d7913-5870-74f1-bdec-9670183bddc2.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "http://www.vonmaur.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6320247291468305010&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "von-maur",
      "poi_latitude": "35.6125387",
      "poi_longitude": "-97.5566093",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-751-1424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-baeb-706e-b972-dc0f3a4634a2",
        "storage_key": "property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp-KJfGccsocRctKX7GwHtlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_418a27f5-0666-4be4-87fc-24a6ce84ca0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "The Wardrobe Modern Menswear",
      "poi_type": "Shopping & Retail",
      "poi_address": "2229 NW 138th St # J, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Clothing store featuring a range of suits and accessories, plus custom tailoring.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-56db-7058-8674-289907712ca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-56db-7058-8674-289907712ca9",
        "storage_key": "property/6767906449165626/019d7913-56db-7058-8674-289907712ca9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://thewardrobeokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11937891361944845156&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-wardrobe-modern-menswear",
      "poi_latitude": "35.6131021",
      "poi_longitude": "-97.5528424",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-286-3637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-baeb-706e-b972-dc0f3a4634a2",
        "storage_key": "property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhV_54WkcsocRZDvtq_Hoq6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_245e7020-da8e-4d43-921a-f69df2f5210c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Hobby Lobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "2201 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_long_description": "People say this craft store offers a wide variety of seasonal decorations, DIY supplies, and jewelry-making materials. They highlight the great deals, especially during sales, and the well-stocked shelves. They also like the helpful and responsive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-60c4-705d-8638-9ebb11aaf8bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-60c4-705d-8638-9ebb11aaf8bd",
        "storage_key": "property/6767906449165626/019d7913-60c4-705d-8638-9ebb11aaf8bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hobbylobby.com/stores/search/124",
      "poi_directions_map_url": "https://maps.google.com/?cid=9419838112277096680&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobby-lobby",
      "poi_latitude": "35.6110267",
      "poi_longitude": "-97.5521011",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-753-9417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-baeb-706e-b972-dc0f3a4634a2",
        "storage_key": "property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ72uN-WkcsocR6Gj2y9r8uYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_68361e62-cacc-45e3-a27e-a175347f3986",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Carter's",
      "poi_type": "Shopping & Retail",
      "poi_address": "13726 N Pennsylvania Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Baby & kids' apparel brand known for its colorful, basic clothing & accessories.",
      "poi_long_description": "Baby & kids' apparel brand known for its colorful, basic clothing & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-6788-7756-b681-9b3b096077e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6788-7756-b681-9b3b096077e8",
        "storage_key": "property/6767906449165626/019d7913-6788-7756-b681-9b3b096077e8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.carters.com/l/ok/oklahoma-city/carters-memorial-square-0849",
      "poi_directions_map_url": "https://maps.google.com/?cid=6642342807670866034&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carter-s",
      "poi_latitude": "35.6103019",
      "poi_longitude": "-97.5467987",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-753-9402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-baeb-706e-b972-dc0f3a4634a2",
        "storage_key": "property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-xwB4nUcsocRcsCXR5dXLlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_dda190a5-1884-4c06-afff-e17844eafd2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "At Home",
      "poi_type": "Shopping & Retail",
      "poi_address": "2201 NW 138th St, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain retailer for home decor such as bedding and furniture, plus holiday and outdoor items.",
      "poi_long_description": "People say this home goods store offers a wide variety of home decor, including Halloween decor, kitchen accessories, storage solutions, and furniture, at affordable prices. They also highlight the spacious layout, allowing customers to browse comfortably.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-63d4-7540-b04c-76e406ffddb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-63d4-7540-b04c-76e406ffddb8",
        "storage_key": "property/6767906449165626/019d7913-63d4-7540-b04c-76e406ffddb8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.athome.com/store/oklahoma-oklahoma-city-north/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5326617560524437868&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "at-home",
      "poi_latitude": "35.61290839999999",
      "poi_longitude": "-97.5517935",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-241-3858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-baeb-706e-b972-dc0f3a4634a2",
        "storage_key": "property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnzAJXWocsocRbLlqHXPy60k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_e85a6e80-4de7-4592-a500-0d06d3ad4e9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Petland Oklahoma City",
      "poi_type": "Shopping & Retail",
      "poi_address": "13820 N Pennsylvania Ave Unit #8, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Retail chain stocking a wide range of pet supplies, including food, bedding & grooming products.",
      "poi_long_description": "People say this pet store offers a wide variety of puppies, birds, rabbits, and other small animals. They highlight the puppies are fun to play with and the staff is friendly and helpful. They also like the clean and well-maintained environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-6fc5-751b-bbd0-b56e400a94f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6fc5-751b-bbd0-b56e400a94f2",
        "storage_key": "property/6767906449165626/019d7913-6fc5-751b-bbd0-b56e400a94f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://petlandoklahoma.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=14875109340190871849&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petland-oklahoma-city",
      "poi_latitude": "35.611083",
      "poi_longitude": "-97.5482297",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-591-2438",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-baeb-706e-b972-dc0f3a4634a2",
        "storage_key": "property/6767906449165626/019cfb47-baeb-706e-b972-dc0f3a4634a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz0rCtbYdsocRKREsGSIBb84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_store"
    },
    {
      "id": "custom_93bf03e5-50ed-43b6-b6fd-0192c78cd7a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Oklahoma City Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2000 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_long_description": "Visitors say this zoo offers a wide variety of animals, including elephants, giraffes, stingrays, and a petting zoo, with fun activities like giraffe feeding and a splash pad. They also highlight the friendly and helpful staff, the clean and well-maintained facilities, and the affordable prices, especially with discounts for families and military members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-7205-70df-ac9e-5588827fc981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7205-70df-ac9e-5588827fc981",
        "storage_key": "property/6767906449165626/019d7913-7205-70df-ac9e-5588827fc981.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://okczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013321368135377402&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-zoo",
      "poi_latitude": "35.5238895",
      "poi_longitude": "-97.4724932",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-424-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae0-7364-b1b5-5defddee659c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae0-7364-b1b5-5defddee659c",
        "storage_key": "property/6767906449165626/019cfb47-bae0-7364-b1b5-5defddee659c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_EZ4YPguocR-qGV_DjlkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_b3b50d18-00b6-45c5-997f-4e88fe3d9530",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Oklahoma Railway Museum",
      "poi_type": "Entertainment",
      "poi_address": "3400 NE Grand Blvd, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Restored locomotives, a 19th-century depot & memorabilia displays, plus seasonal train rides.",
      "poi_long_description": "People say this museum offers a variety of locomotives, rolling stock, and model trains, and provides fun train rides. They highlight the free admission and affordable train ride tickets, and the fun, family-friendly atmosphere. They also like the friendly, informative, and accommodating staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-7151-716d-a4cd-632476a9aa24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7151-716d-a4cd-632476a9aa24",
        "storage_key": "property/6767906449165626/019d7913-7151-716d-a4cd-632476a9aa24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://oklahomarailwaymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15454060272610611984&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-railway-museum",
      "poi_latitude": "35.5051862",
      "poi_longitude": "-97.4671897",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-424-8222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-baeb-706e-b972-dacfe15a71cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-baeb-706e-b972-dacfe15a71cd",
        "storage_key": "property/6767906449165626/019cfb47-baeb-706e-b972-dacfe15a71cd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZWrAP4kXsocREJNuVvDZd9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c10dfe3b-5bb2-47a9-af14-007febde46c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Frontier City",
      "poi_type": "Entertainment",
      "poi_address": "11501 N I- 35 Service Rd, Oklahoma City, OK 73131, USA",
      "poi_short_description": "Western-themed amusement park offering thrill, kids' & water rides plus multiple shows & eateries.",
      "poi_long_description": "People say this theme park offers a variety of thrill rides, water rides, and live shows. They also highlight the short wait times, fun atmosphere, and friendly staff.\n\nOther reviews mention the parking can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-788c-72ae-965f-b14c8d350cb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-788c-72ae-965f-b14c8d350cb0",
        "storage_key": "property/6767906449165626/019d7913-788c-72ae-965f-b14c8d350cb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/frontiercity",
      "poi_directions_map_url": "https://maps.google.com/?cid=7374031908058551867&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "frontier-city",
      "poi_latitude": "35.5856674",
      "poi_longitude": "-97.4394665",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-478-2140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae0-7364-b1b5-5defddee659c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae0-7364-b1b5-5defddee659c",
        "storage_key": "property/6767906449165626/019cfb47-bae0-7364-b1b5-5defddee659c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEzIo0KYYsocRO9Y5evPSVWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_a22cbec0-8e93-40f9-8cee-1bddd9fcfa68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Wheeler District",
      "poi_type": "Entertainment",
      "poi_address": "Runway Blvd, Oklahoma City, OK 73109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-8515-7510-b5e7-bc75eff4d3ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8515-7510-b5e7-bc75eff4d3ca",
        "storage_key": "property/6767906449165626/019d7913-8515-7510-b5e7-bc75eff4d3ca.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.wheelerdistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14391442457183523700&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wheeler-district",
      "poi_latitude": "35.447546",
      "poi_longitude": "-97.5325937",
      "poi_miles_from_property": "13.6 mi",
      "poi_walking_minutes": "5 hours 5 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-609-2994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae0-7364-b1b5-5defddee659c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae0-7364-b1b5-5defddee659c",
        "storage_key": "property/6767906449165626/019cfb47-bae0-7364-b1b5-5defddee659c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZblgEkRsocRdBPmaaqsuMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_264ee62b-ee1f-49cc-bc28-7572dc06e88a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Quail Creek Golf & Country Club",
      "poi_type": "Entertainment",
      "poi_address": "3501 Quail Creek Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Upscale facility, owned by members, featuring golf courses and tennis courts, plus a pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-8998-722b-becc-d56907651a95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8998-722b-becc-d56907651a95",
        "storage_key": "property/6767906449165626/019d7913-8998-722b-becc-d56907651a95.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.quailcreekgcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3160679487445955446&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "quail-creek-golf-country-club",
      "poi_latitude": "35.5992235",
      "poi_longitude": "-97.5817331",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-751-0811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae0-7364-b1b5-5defddee659c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae0-7364-b1b5-5defddee659c",
        "storage_key": "property/6767906449165626/019cfb47-bae0-7364-b1b5-5defddee659c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJdotho8csocRdnMUcj_93Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_df86b21e-b2c8-4ffc-9a58-f56f16f4162d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "poi_name": "Stinchcomb Wildlife Refuge",
      "poi_type": "Entertainment",
      "poi_address": "5100 N Stinchcomb Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Forested wildlife area for hiking, bird-watching, fishing & biking as well as kayaking.",
      "poi_long_description": "People say this wildlife refuge offers hiking trails, kayaking, and fishing opportunities. They highlight the beautiful scenery, access to the river, and the abundance of wildlife, including birds and snakes. They also like the opportunity to get off in nature and enjoy a peaceful escape.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019d7913-86cf-74cb-a969-853086a5b951.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-86cf-74cb-a969-853086a5b951",
        "storage_key": "property/6767906449165626/019d7913-86cf-74cb-a969-853086a5b951.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=16862425980734090786&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stinchcomb-wildlife-refuge",
      "poi_latitude": "35.5227424",
      "poi_longitude": "-97.6633716",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 22 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-bae1-74b9-840a-ebbeee6fb9e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-bae1-74b9-840a-ebbeee6fb9e9",
        "storage_key": "property/6767906449165626/019cfb47-bae1-74b9-840a-ebbeee6fb9e9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85Pzk84FsocRIi75qBZfA-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    }
  ],
  "office_hours": [
    {
      "id": "ec_53af069d5fc2ac97d7a4fcfd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b84e820ed6ef141a4b4158a9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b6530864d7b72f4fdc78c950",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0749cf128ce2f17a8826dc8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_b84dfd7afa6d69ae7fca9a5b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_19b33fee44b25be75050cc75",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_359695c898d2e81da72b7d22",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_7fca9f39-a83d-4b2e-a46f-75c9878b9d65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "rating": "5.0",
      "name": "Ron C",
      "text": "I’ve only lived here 2.5 mos so far but the complex has been quiet and inviting. Office staff is always friendly and helpful. Maintenance has been very quick to respond to small issue. I’d recommend Stonehorse Crossing.",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_42188ab0-0c36-4b98-adce-2734975ae1fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "rating": "5.0",
      "name": "Jessica Van Dam",
      "text": "This is the most peaceful place to live. I love the location, it’s central to everything, i love my beautiful little apartment, and my pool view with the sound of the fountains is so zen . Management here is wonderful- Tonia in the front office, besides being like a walking hug, is so knowledgeable and helpful with any questions I’ve ever had. and Ryan the new manager is very approachable and professional. The property is maintained nicely too, the landscapers are always busy bees and it looks beautiful.\n\nI had a small flood once in my place from a wash machine malfunction and a super nice maintenance man showed up at midnight and calmed my nerves and helped me fix and dry everything, even though it was my own machine that did it and not anything I would think was the responsibility of the property. He was reassuring and saved my butt and my carpet . I was grateful.\n\nHighly recommend Stonehorse to anyone who wants a peaceful home- I see why it gets such a high rating . love living here",
      "date": "2023-01-17",
      "title": ""
    },
    {
      "id": "custom_ae55385b-2da7-4829-9498-ce4ce80b97d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "rating": "5.0",
      "name": "Brittany Dalton",
      "text": "I have not quite moved in yet, but I had to give credit where credit is due for the management during the search and then signing process. The leasing consultant and manager were both above and beyond in the help given, patiently answering all my many, many questions and working with me to quickly get beyond any hurdles that popped up. They also communicated proactively with me by updating me daily for a stretch of time until my signing, so that I could find the apartment that fit everything I desired most.\n\nI went to show off my new neighborhood to family a few different times before I move in, and each time the gate was closed where we weren't able to get in. That actually is really reassuring to me, because I've dealt with safety issues and break-ins elsewhere in complexes that had a gate.\n\nHopeful that this experience will continue to be positive and that I'll be able to stay in one place for longer than any of the other communities. Kudos to the front office for easing so much of my worry and making moving exciting, not scary! 😊",
      "date": "2025-04-18",
      "title": ""
    },
    {
      "id": "custom_cb6150db-3e7c-4526-a169-ef00ca788f80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "rating": "5.0",
      "name": "David Toney",
      "text": "Stone Horse Crossing has been awesome. They are very easy to work with and have helped me several times when i've needed.",
      "date": "2025-08-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_78531e4d-e659-4625-8aed-2d9ec11eccf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb48-5ec9-7312-b158-a01ed5e7486b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of apartment community lounge with pool table and kitchen",
        "public_id": "019cfb48-5ec9-7312-b158-a01ed5e7486b",
        "storage_key": "property/6767906449165626/019cfb48-5ec9-7312-b158-a01ed5e7486b.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Stonehorse Crossing Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62fe326a53dd6e409cd861a0"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-62fe-732e-bc12-b435493edaae",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "stonehorse-crossing",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626"
    },
    {
      "lead_collector_id": "019cf79e-636f-711b-996c-cdd9c7d3e28b",
      "lead_source": "LANDING_PAGE",
      "name": "stonehorse-crossing",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-oklahoma-city",
      "search_query": "apartments with in-unit laundry Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry OKC",
      "h2_subtitle": "Find spacious apartments with in-unit laundry in Oklahoma City at Stonehorse Crossing. Enjoy modern amenities in a vibrant community setting.",
      "page_copy": "Discover the perfect blend of convenience and comfort at Stonehorse Crossing, where each apartment features in-unit laundry facilities right in Oklahoma City. Our spacious one- and two-bedroom floor plans are thoughtfully designed with modern living in mind, boasting granite countertops and stainless steel appliances.\n\nNestled in the inviting neighborhood of Northwest Oklahoma City, residents enjoy exclusive access to resort-style amenities, including a state-of-the-art fitness center, sparkling pool, and a pet-friendly dog park. Experience the convenience of an apartment with in-unit laundry today—schedule a tour and make Stonehorse Crossing your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019cfb47-9e9d-738f-80d1-d30340e04168",
        "storage_key": "property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry OKC",
      "seo_description": "Find your ideal home with in-unit laundry at Stonehorse Crossing, offering modern amenities in Oklahoma City. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "generator",
      "page_item_url": "okc-air-conditioned-apartments",
      "search_query": "Oklahoma City apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "OKC Apartments with Air Conditioning",
      "h2_subtitle": "Enjoy cool comfort in Oklahoma City apartments with air conditioning at Stonehorse Crossing. Experience superior modern living today.",
      "page_copy": "Beat the Oklahoma heat with Stonehorse Crossing's air-conditioned apartments, situated in the heart of Oklahoma City. Our one- and two-bedroom floor plans offer a cool sanctuary with top-notch amenities such as granite countertops and stainless steel appliances that elevate everyday living.\n\nLocated in vibrant Northwest Oklahoma City, our community offers more than just air-conditioned comfort. Indulge in a suite of resort-style amenities, including a sparkling pool, a fitness center tailored to your active lifestyle, and a dog park for your furry friends. Discover the optimal blend of comfort and style—visit Stonehorse Crossing and chill in your new air-conditioned home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019cfb47-9e9d-738f-80d1-d30340e04168",
        "storage_key": "property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "OKC Apartments with Air Conditioning",
      "seo_description": "Stay cool at Stonehorse Crossing's air-conditioned apartments in OKC. Modern amenities and vibrant community await!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "generator",
      "page_item_url": "northwest-okc-apartments-dedicated-parking",
      "search_query": "apartments with dedicated parking in Northwest Oklahoma City",
      "category": "Amenity",
      "h1_title": "NW OKC Apartments with Dedicated Parking",
      "h2_subtitle": "Discover convenience in Northwest Oklahoma City. Our apartments offer dedicated parking and a host of modern amenities at Stonehorse Crossing.",
      "page_copy": "Located in the heart of Northwest Oklahoma City, Stonehorse Crossing provides apartments with dedicated parking, ensuring convenience and accessibility for all residents. Choose from our spacious one- and two-bedroom floor plans, each thoughtfully crafted with modern touches like granite countertops and stainless steel appliances, perfect for contemporary living.\n\nAlongside the ease of dedicated parking, you'll enjoy access to a range of lifestyle amenities. Unwind by our resort-style pool, stay fit in our 24-hour accessible fitness center, or enjoy quality time with your pet at our dedicated dog park. Experience the perfect blend of modern luxury and everyday convenience at Stonehorse Crossing—your ideal home in Northwest Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019cfb47-9e9d-738f-80d1-d30340e04168",
        "storage_key": "property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "NW OKC Apartments with Dedicated Parking",
      "seo_description": "Enjoy dedicated parking in NW Oklahoma City at Stonehorse Crossing. Modern living with exclusive amenities awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "generator",
      "page_item_url": "okc-dog-park-apartment-living",
      "search_query": "Oklahoma City dog park apartment living",
      "category": "Amenity",
      "h1_title": "Dog Park Apartment Living in OKC",
      "h2_subtitle": "Experience the best in Oklahoma City dog park apartment living at Stonehorse Crossing. Enjoy spacious apartments and pet-friendly amenities designed for you.",
      "page_copy": "Discover the joys of dog park apartment living at Stonehorse Crossing, where Oklahoma City's pet-friendly lifestyle comes to life. Our community offers one- and two-bedroom apartments, each with refined features like granite countertops, stainless steel appliances, and in-unit laundry.\n\nResidents enjoy a vibrant community setting with a dog park perfect for playdates and strolls with furry friends. Beyond pet-friendly amenities, enjoy a resort-style pool and a state-of-the-art fitness center. Located in Northwest OKC, Stonehorse Crossing offers a unique blend of comfort and community for both you and your pets. Schedule a tour today and discover apartment living that caters to you and your four-legged companions!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019cfb47-9e9d-738f-80d1-d30340e04168",
        "storage_key": "property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartment Living in OKC",
      "seo_description": "Experience pet-friendly living at Stonehorse Crossing's dog park apartments in OKC. Modern amenities and pet-friendly fun await!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "generator",
      "page_item_url": "luxury-apartments-swimming-pool-73134",
      "search_query": "luxury apartments with swimming pool 73134",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in 73134",
      "h2_subtitle": "Explore luxury apartment living with a swimming pool in the 73134 area at Stonehorse Crossing. Enjoy upscale amenities in a vibrant community.",
      "page_copy": "In the heart of the 73134 area, Stonehorse Crossing offers luxury apartments complete with a refreshing swimming pool and a host of upscale amenities. Our one- and two-bedroom floor plans are designed for comfort and style, boasting enhancements like granite countertops and stainless steel appliances.\n\nResidents indulge in a resort-inspired lifestyle with exclusive access to a sparkling pool, perfect for unwinding or enjoying sunny Oklahoma days. Beyond the pool lies a fitness center equipped for all your workout needs and spacious dog park, catering to pet lovers. Experience luxury living at its finest in Oklahoma City's 73134 region at Stonehorse Crossing.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019cfb47-9e9d-738f-80d1-d30340e04168",
        "storage_key": "property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in 73134",
      "seo_description": "Discover luxury living with a swimming pool at Stonehorse Crossing in the 73134 zip. Quality amenities in a vibrant community await!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-nw-okc",
      "search_query": "one bedroom apartments northwest oklahoma city",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in NW OKC",
      "h2_subtitle": "Find your ideal one bedroom apartment in Northwest Oklahoma City at Stonehorse Crossing. Enjoy modern comforts and exceptional amenities.",
      "page_copy": "Discover your ideal one bedroom apartment in Northwest Oklahoma City at Stonehorse Crossing, where comfort meets style in our well-appointed living spaces. Our apartments are thoughtfully designed with features like granite countertops, stainless steel appliances, and walk-in closets, ensuring modern living at its finest.\n\nAt Stonehorse Crossing, residents enjoy a vibrant community atmosphere enhanced by exceptional amenity offerings. Dive into relaxation at our resort-style pool, maintain an active lifestyle at our fully-equipped fitness center, or enjoy tranquil moments in our lush surroundings. Conveniently located in Northwest OKC, our community provides an unparalleled living experience. Schedule a tour today to find your next home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019cfb47-9e9d-738f-80d1-d30340e04168",
        "storage_key": "property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in NW OKC",
      "seo_description": "Explore one bedroom apartments in NW Oklahoma City at Stonehorse Crossing. Enjoy modern style and exceptional amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165626",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-okc-73134",
      "search_query": "two bedroom apartments near oklahoma city 73134",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near OKC 73134",
      "h2_subtitle": "Explore spacious two bedroom apartments near Oklahoma City in the 73134 area at Stonehorse Crossing. Enjoy upscale living and convenient amenities.",
      "page_copy": "At Stonehorse Crossing, we offer spacious two bedroom apartments near Oklahoma City in the desirable 73134 zip code. Our well-designed floor plans feature modern upgrades such as stainless steel appliances and granite countertops, providing a perfect blend of style and practicality.\n\nEnjoy community amenities that elevate living, such as our inviting swimming pool, state-of-the-art fitness center, and a serene dog park for your furry companions. Nestled in Northwest Oklahoma City, Stonehorse Crossing provides an ideal location with easy access to the urban conveniences of OKC while offering a peaceful community atmosphere. Discover your perfect home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019cfb47-9e9d-738f-80d1-d30340e04168",
        "storage_key": "property/6767906449165626/019cfb47-9e9d-738f-80d1-d30340e04168.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near OKC 73134",
      "seo_description": "Find spacious two bedroom apartments near Oklahoma City in the 73134 area at Stonehorse Crossing. Modern amenities and a prime location await!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5214"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-9HC0R77CZ5"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151812"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/stonehorse-crossing/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N5974PJV"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165626/019d1bd9-be53-732a-b857-ca83f3442873.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "180e69e7-57a7-4ca7-9f09-33ef64a1b9f1"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-694-5472"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64deac14b566015c0abaf727"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InpQbG9oTitvcVZlelFrNStZTEdhR3c9PSIsInZhbHVlIjoibnVsL1EyUzIzRUhoSU10Nm11c25OUT09IiwibWFjIjoiZDQ2ZWJiZDNmYjUyZjgzZmYyZmQ4MGNkMDEzZDRlM2FkYWQzZTFkYzIzZWY4N2IxMzFhZDViMjY1MWIzY2FjNCJ9"
    }
  ],
  "custom_qb_id": "5214",
  "custom_ga4_id": "G-9HC0R77CZ5",
  "custom_repli_id": "10041151812",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/stonehorse-crossing/register/",
  "custom_google_gtm_id": "GTM-N5974PJV",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165626/019d1bd9-be53-732a-b857-ca83f3442873.pdf",
  "custom_rentgrata_property_id": "180e69e7-57a7-4ca7-9f09-33ef64a1b9f1",
  "custom_ppc_tracking_phone_number": "844-694-5472",
  "custom_residentboost_apartment_id": "64deac14b566015c0abaf727",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InpQbG9oTitvcVZlelFrNStZTEdhR3c9PSIsInZhbHVlIjoibnVsL1EyUzIzRUhoSU10Nm11c25OUT09IiwibWFjIjoiZDQ2ZWJiZDNmYjUyZjgzZmYyZmQ4MGNkMDEzZDRlM2FkYWQzZTFkYzIzZWY4N2IxMzFhZDViMjY1MWIzY2FjNCJ9"
};

export const generatedAt = '2026-08-27T21:36:37.030Z';
